export const EsTranslation = {
  lang: 'es',
  data: {
    CULTURE: {
      TITLE_MODAL: 'Seleccione el idioma',
      ITALIAN: 'Italiano',
      ENGLISH: 'Inglés',
      FRENCH: 'Francés',
      SPANISH: 'Español',
      GERMAN: 'Alemano',
    },
    PRODUCTS_LIST: {
      ACTIONS: 'Acciones en todos los productos',
      HANDLE_IMAGES: 'Administrar imágenes'
    },
    MENU: {
      UTILITIES: {
        UTILITIES: 'Utilidades',
        BULK_OPERATIONS: 'Operaciones',
      },
      DASHBOARD: 'Tablero',
      ORDERS: 'Pedidos',
      CARTS: 'Carritos',
      PROMOTIONS: 'Promociones',
      CUSTOMIZATION_REQUESTS: 'Solicitudes personalización',
      AUTOMATIC_DISCOUNTS: 'Descuentos automáticos',
      CUSTOMER_DISCOUNTS: 'Descuento al cliente',
      STORECHANNEL_DISCOUNT: 'Descuentos store-channel',
      GOK_MODE: 'Gok',
      DIRECT_MODE: 'Orden directa',
      VOUCHERS: 'Vouchers',
      COMMERCIAL_AGREEMENTS: 'Acuerdos comerciales',
      CUSTOMERS_DISCOUNTS: 'Descuentos de clientes',
      AGENTS: 'Agentes',
      GENERAL_FIELDS: 'Campos generales',
      AGENCY_INFO: 'Información de la agencia',
      CUSTOMER_INFO: 'Información del cliente',
      CATEGORIES: 'Grupo de Clasificación del Cliente',
      PAYMENT_TERMS: 'Términos de pago',
      COMPANY_FORMS: 'Forma Jurídica de la Empresa',
      DOWNLOADS: {
        DOWNLOADS: 'Descargas',
        REPORTS: 'Reports'
      },
      PRODUCTS: {
        NAME: 'Productos',
        PRODUCTS_LIST: 'Lista de productos',
        INVENTORY_VISIBILITY: '	Visibilidad del inventario',
        ASSORTMENTS: 'Asortamientos',
        IMPORT_PRODUCTS: 'Importar productos',
        BULK_EDITOR: 'Editor en bloque',
        VARIANT_BULK_EDITOR: 'Editor variantes',
      },
      SETTINGS: {
        NAME: 'Ajustes',
        STORE_SETTINGS: 'Ajustes de la tienda',
        PRICE_LIST: 'Lista de precios',
        TIERS: 'Tiers',
        SALES_CAMPAIGNS: 'Campañas de ventas',
        TERMS_OF_SALE: 'Términos de venta',
        SEASON_REFERENCE: 'Season Reference',
        PACKAGE_GROUP: 'Package Group',
        TRANSPORT_AGENCY: 'Agencia de transporte',
        ORDER_LABEL: 'Order label (opcional)',
        DEFAULT: 'Por defecto',
        EMAIL_SETTINGS: 'Ajustes de correo electrónico',
        EMAIL_FOR_CHANNEL: 'E-mail para el canal',
        OVERRIDE_EMAIL_INFO: 'A continuación puede especificar diferentes correos electrónicos para cada canal de ventas. Si no se especifica un correo electrónico para un canal, se utilizará el correo electrónico predeterminado.',
        SHIPPING_COST_SETTINGS: 'Ajustes de costos de envío',
        FREE_SHIPPING_THRESHOLD: 'Umbral de envío gratuito',
        SHIPPING_COST: 'Costo de envío',
        NUMBER_OF_DAYS_TO_CALCULATE_THE_RE_ORDER_DATE: 'Número de días para calcular la fecha de re-order',
        DEFAULT_LIMIT_FOR_STYLE_COLOR_OF_MONOBRAND_STORES: 'Límite de compra por defecto en estilo-color (para canales de venta que lo requieran)',
        MINIMUM_VALUE_FOR_THE_TOTAL_ORDER_AMOUNT: 'Valor mínimo de un carrito para crear el pedido correspondiente (para canales de venta que lo requieran)',
        FREE_SHIPPING_ORDER_TOTAL_THRESHOLD: 'Valor mínimo de un carrito para que el envío sea gratuito (para canales de venta que lo requieran)',
        GENERAL: 'General',
        STORE_NAME: 'Nombre',
        DISCOUNT: 'Descuento',
        CURRENCY: 'Divisa',
        SALES_SETTINGS: 'Ajustes de ventas',
        PRE_ORDER_ACTIVE_FROM: 'Pre-order activo desde',
        PRE_ORDER_ACTIVE_TO: 'Pre-order activo para',
        RE_ORDER_ACTIVE_FROM: 'Re-order activo desde',
        RE_ORDER_ACTIVE_TO: 'Re-order activo para',
        MAX_CUSTOM_DATES: 'Fecha de entrega personalizada posible hasta',

        BACKGROUND_IMAGE: 'Imagen de fondo',
        LOGO_IMAGE: 'Imagen de logotipo',
        FAVICON_IMAGE: 'Fav icon',
        ADD: 'Agregar',
        CHANGE: 'Cambio',
        SMALL_LOGO: 'Logotipo pequeño',

        UPLOAD_MEDIA: 'Subir medios',
        UPLOAD_EXCEL: 'Subir Excel',
        SAVE: 'Salvar',
        UPLOAD_FILE: 'Subir archivo',
        AVILABLE_FILE_SIZE: 'Tamaño máximo del archivo',

        PRIMARY_COLOR: 'Color primario',
        MAIL_NOTIFICATIONS: 'E-mail recibiendo notificaciones de la tienda',
        MAIL_SENDER: 'E-mail del remitente de la tienda',
        FOOTER_TEXT: 'Footer text',
        CART_NAME_MAX_LENGTH: 'Longitud máxima del nombre de un carrito',
        CART_NOTIFICATION_SETTINGS: 'Configuración de notificaciones de carrito inactivo',
        CART_NOTIFICATION_THRESHOLD: 'Umbral de eliminación de notificaciones de carrito en días',
        CART_NOTIFICATION_DELETION_THRESHOLD: 'Umbral de eliminación de carritos inactivos en días',
        DEFAULT_DESIGNER: 'Diseñador por defecto',
        KUSTOM_EMAIL: 'E-mail Kustom',
        KUSTOM_PHONE: 'Telefono Kustom',
        KUSTOM_EMAIL_SECONDARY: 'E-mail Kustom secundario',
        KUSTOM_SETTINGS: 'Ajustes BasicKustom',
        KUSTOM_MIN_QUANTYTY_FOR_PRODUCT: "Cantidad mínima de compra para producto personalizado en solicitudes",
        ENABLE_KUSTOM: 'BasicKustom habilitado',
        DISABLE_KUSTOM: 'BasicKustom deshabilitado',
        PLEASE_FILL_ALL_REQUIRED_FIELDS: 'Por favor, rellena todos los campos obligatorios',
      },
      AGENCIES: 'Agencias',
      CUSTOMERS: 'Clientes',
      USERS: 'Usuarios',
      LOCATIONS: 'Ubicaciones',
      TUTORIAL: {
        NAME: 'Tutorial',
        VIDEO: 'Video',
      },
    },
    IMPORT_PRODUCTS: {
      START_SEARCH: 'Introduce el texto de búsqueda para comenzar la importación',
      DESELECT_ALL: 'Deseleccionar todo',
      RELOAD_PRODUCTS: 'Recargar productos',
      ID: 'ID',
      NAME: 'Nombre',
      SELLING_PERIOD: 'Período de venta',
      PRODUCTS_QUANTITY: 'Cantidad de productos',
      LOAD_MORE_DATA: 'Cargar más datos',
      THERE_IS_NO_MORE_DATA: 'No hay más datos',
      STATUS: {
        IMPORTED: 'Importado',
        NOT_IMPORTED: 'No importado',
        IMPORTING: 'Importación..',
        FAILED: 'Fallado'
      },
      MODAL: {
        TITLE: 'Importar productos',
        YOU_HAVE_SELECTED: 'Ha seleccionado',
        ITEMS: 'elementos',
        ATTENTTION_YOU_ARE_IMPORTING: '¡Atención! Está importando',
        MESSAGE: 'estilos ya importados. Todos los cambios al respecto y sus variantes se perderán. ¿Está seguro?',
        YOU_HAVE_TO_SELECT_AT_LAST_ONE_ITEM: 'Debe seleccionar al menos un elemento',
        USE_CUSTOM_DISCOUNT: 'Establecer descuento personalizado para calcular el precio wholesale',
        USE_CUSTOM_DISCOUNT_INFO: 'Si configura un descuento personalizado, se utilizará para calcular el precio wholesale de todas las variantes de productos en importación, tanto para el cálculo del precio del PRE order como del RE order. Si no lo configura, se usará el último porcentaje utilizado para los productos que ya se importaron en el pasado y el descuento base de la tienda actual para los productos que nunca se importaron.'
      }
    },
    USERMENU: {
      SHOP: 'Tienda',
      MY_PROFILE: 'Mi perfil',
      LOGOUT: 'Cerrar sesión',
      SWITCH_TENANT: 'Cambiar de país',
      LOGOUT_CONFIRM: '¿Estás seguro de que quieres salir?',
      CANCEL: 'Cancelar',
    },
    BACK_TO: {
      SALES_CAMPAIGN: 'Volver a la campaña de ventas',
      SALES_CAMPAIGNS: 'Volver a campañas de ventas',
    },
    GENERIC_LABEL: {
      SELECT: 'Seleccionar',
      SELECT_SIZE: 'Seleccionar talla',
      APPROVE: 'Aprobar',
      COPY: 'Copiar',
      SALE_CAMPAIGN: 'Campaña de ventas',
      CHOOSE_FILE: 'Elija el archivo',
      BACK: 'Volver',
      SYNC_START: 'Sincronización iniciada',
      ADD_NEW: 'Añadir nuevo',
      ADD: 'Añadir',
      SAVE: 'Guardar',
      SAVE_CHANGES: 'Guardar cambios',
      DELETE: 'Eliminar',
      CANCEL: 'Cancelar',
      CLOSE: 'Cerrar',
      TRANSFORM_INTO_DRAFT: 'Volver a convertir en carrito',
      LEAVE_PAGE: 'Dejar esta página',
      ACTIONS: 'Acciones',
      UPLOAD: 'Subir',
      IMPORT: 'Importar',
      DUPLICATE: 'Duplicar',
      CONFIRM: 'Confirmar',
      SEND_CONFIRMATION_MAIL: 'Reenviar e-mail de confirmación',
      EDIT: 'Editar',
      EDIT_ITEMS: 'Editar artículos',
      EDIT_CART: 'Editar carrito',
      ACTIVATE: 'Activar',
      SEND: 'Enviar',
      RESEND: 'Reenviar',
      DEACTIVATE: 'Desactivar',
      FORM_ERROR: 'Datos faltantes o incorrectos',
      YES: 'Sí',
      NO: 'No',
      PRINT: 'Imprimir',
      PRINT_PREVIEW: 'Vista previa de impresión',
      ERROR: 'Error!',
      ARE_YOU_SURE: '¿Estás seguro?',
      ARE_YOU_SURE_YOU_WANT_TO_PROCEED: '¿Estás seguro de que quieres proceder?',
      REMOVE: 'Eliminar',
      DONE: '¡Hecho!',
      BLOCKED: 'Bloqueado',
      UNBLOCKED: 'No bloqueado',
      USER: 'Usuario',
      ACTIVATED: 'Activado',
      DEACTIVATED: 'Desactivado',
      MAN: 'Hombre',
      WOMAN: 'Mujer',
      UNISEX: 'Unisex',
      UNPUBLISH: 'Despublicar',
      LOSING_CHANGES_MESSAGE: 'Los cambios no guardados se perderán. Quieres ¿proceder?',
      SETTINGS: 'Ajustes',
      START_SYNC: 'Iniciar alineación con ERP',
      THE_VALUE_MUST_BE_BETWEEN: 'El valor debe estar entre {{min}} y {{max}}',
      MAX_LENGTH: 'Máximo {{max}} caracteres, actualmente {{actual}}',
      ATTENTION: 'Atención!',
      PREVIEW: 'Vista previa',
      DOWNLOAD: 'Descargas {{extension}}',
      APPLY: 'Aplicar',
      NEXT: 'Siguiente',
      SELECT_CODE: 'Seleccionar código',
      DOWNLOAD_REPORT: 'Descargar reportes',
      EXPORT_ORDERS: 'Exportar órdenes',
      ONLY_WITH_STOCK_PRODUCTS: 'Solo productos disponibles',
      PRODUCT_TYPE: 'Tipo de producto',
      REPORTS_MODAL_MESSAGE: 'Establece los filtros que desees y recibirás el informe en tu correo electrónico.',
      STORE_VARIANTS_REPORT: 'Reporte de variantes de tienda',
      CUSTOMER_REPORT: 'Reporte de clientes',
      FROM_DATE: 'De',
      TO_DATE: 'Al',
      SALES_CAMPAIGN: 'Campaña de ventas',
      SELECTED_ORDERS: 'Órdenes seleccionadas',
      NO_ORDERS_SELECTED: 'Ninguna orden seleccionada',
      SELECTED: 'Seleccionados',
      EDIT_SELECTED_ORDERS: 'Editar órdenes seleccionadas',
      DELETE_ORDERS: 'Eliminar órdenes',
      CANCEL_ORDERS: 'Cancelar pedidos',
      DELETE_ORDERS_BY_EXCEL: 'Eliminar órdenes por Excel',
      SUCCESS_DELETE_ORDERS: 'Órdenes eliminadas con éxito',
      UPLOAD_ORDERS_TEMPLATE: 'Sube los artículos de tus pedidos usando la plantilla',
      DOWNLOAD_TEMPLATE: 'Descargar plantilla',
      ERROR_NEGATIVE_NUMBERS: 'No es posible insertar números negativos o decimales',
      INVALID_QUANTITY: 'Cantidad no valida',
      NAME: 'Nombre',
      CART_QTY: 'artículos en el carrito',
      BULK_SELECTION: 'Selección masiva',
      WORKING_MODE: "Seleccione el modo de trabajo",
      SELECT_FILTERS: "Seleccionar por filtros",
      SELECT_FREE_TEXT: "Seleccionar por external IDs de pedidos",
      ENTER_ORDER_IDS: "Introduzca los IDs de pedido",
      ENTER_ORDER_IDS_PLACEHOLDER: "Escriba o pegue uno o más external IDs de pedido, separados por punto y coma",
      OTHERS: "Otros"
    },
    MANAGE_GENERAL_FIELDS: {
      FIELDS_TYPE: 'Tipo de campos',
      VALUE_SET: 'Conjunto de valores',
      TABLE: {
        VALUE: 'Valor',
        DECIMAL_VALUE: 'Valor decimal',
        CREATION_TIME: 'Fecha de creación',
        LAST_UPDATE: 'Última actualización',
        DELETE_GF: 'Eliminar campo general',
        ARE_YOU_SURE: '¿Estás seguro de que deseas eliminar este campo general?',
        EDIT_GF: 'Editar campo general',
        CREATE_GF: 'Crear nuevo campo general',
        CODE: 'Código',
        DESCRIPTION: 'Descripción',
        ID: 'ID',
        EXTERNAL_ID: 'External ID',
        NAME: 'Nombre',
        ORDER: 'Orden',
      },
    },
    TABLE: {
      ACTION: {
        NAME: 'Acciones',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        CREATE_NEW: 'Crear nuevo',
        EXPORT: 'Exportar',
        IMPORT: 'Importar',
        INVITE_USER: 'Invitar usuario',
        DUPLICATE: 'Duplicar',
        VIEW_DETAILS: 'Ver detalles',
        ACTIVATE: 'Activar',
        DEACTIVATE: 'Desactivar',
        REFRESH: 'Actualizar',
        ARCHIVE: 'Archivo',
        UPLOAD: 'Subir',
        DOWNLOAD_LIST: 'Descargar lista',
        CREATE_CART_FROM_EXCEL: 'Crear carritos desde Excel',
      },
      FILTERS: {
        FILTERS: 'Filtros',
        CREATOR: 'Creador',
        REQUESTER: 'Solicitante',
        CUSTOMER_REQUESTER: 'Solicitante Cliente',
        AGENCY_REQUESTER: 'Solicitante Agencia',
        DESIGNER: 'Diseñador',
        APPROVED_BY: 'Aprobado por',
        APPLY_FILTER: 'Aplicar filtro',
        ACTIVE_FILTERS: 'Filtros activos',
        SEARCH: 'Buscar',
        VISIBILITY_TYPE: 'Tipo',
        TYPE: 'Tipo',
        VALIDITY: 'Validez',
        REORDER: 'Re-order',
        PREORDER: 'Pre-order',
        WHOLESALE_PRICE: 'Precio wholesale',
        NEW_WHOLESALE_PRICE: 'Nuevo precio wholesale',
        FROM: 'De',
        TO: 'A',
        RETAIL_PRICE: 'Precio retail',
        STOCK: 'Stock',
        ASSORTMENT: 'Asortamiento',
        STYLE_GROUP: 'Style group',
        CITY: 'Ciudad',
        TIER: 'Nivel',
        STORE: 'Tienda',
        CUSTOMER: 'Cliente',
        CUSTOMER_TYPE: 'Tipo de cliente',
        AGENCY: 'Agencia',
        ONLINE_STORES: 'Tiendas en línea',
        WITHOUT_STORE: 'Sin tienda',
        POINT_OF_SALE: 'Punto de venta',
        ORDER_STATUS: 'Estado del pedido',
        STATUS: 'Estado',
        LOCATION_TYPE: 'Tipo de ubicación',
        REGISTERED_DATE: 'Fecha de registro',
        ROLE: 'Rol',
        ONLY_INCLUDED: 'Solo incluidos',
        COLORS: 'Colores',
        SIZE: 'Talla',
        SIZE_GROUP: 'Grupo talla',
        NOTES: 'Notas',
        HAS_NOTES: 'Con notas',
        EXTERNAL_COLLECTIONS: 'Colecciones externas',
        EXTERNAL_ORDER_ID: 'ID de pedido externo',
        CHANNEL: 'Canal',
        PRODUCTS: 'Productos',
        OPERATION_TYPE: 'Tipo de operación',
        CUSTOMER_AMMINISTRATIVE_STATUS: 'Estado del bloque comercial',
        SHOW_ONLY_BLOCKED: 'Mostrar solo clientes bloqueados',
        SHOW_ONLY_WITH_CR: 'Mostrar pedidos con solicitudes de personalización asociadas',
        CHANNEL_ID: 'Id canal',
        CREATED_AFTER: 'Creado después de',
        CREATED_BEFORE: 'Creado antes de',
        SELECT_ORDERS: 'Seleccionar pedidos',
        MANAGEMENT_ORDERS: 'Gestionar pedidos',
        SELECTED_ORDERS: 'Pedidos seleccionados',
        NO_ORDERS_SELECTED: 'Ningún pedido seleccionado',
        SELECTED: 'Seleccionados',
        ECPORT_ORDERS: 'Exportar pedidos',
        EDIT_SELECTED_ORDERS: 'Editar pedidos seleccionados',
        COMERCIAL_BLOCK: 'Bloque comercial',
        COMPLETED_AT: 'Completado el',
        SHOW_CR_WITH_DESIGNER_NOTIFICATION: 'Mostrar solo solicitudes de personalización con notificación del solicitante',
        ORDER_BULK_OPERATION_SCOPE: 'Scope operaciones',
        ORDER: 'Pedido',
      },

      CUSTOMIZATION_REQUEST: {
        TITLE: 'Solicitudes de personalización',
        COLUMN: {
          NAME: 'Nombre',
          STATUS: 'Estado',
          CUSTOMER: 'Cliente',
          CHANNEL: 'Canal',
          POINT_OF_SALE: 'Punto de venta',
          TOTAL_WHOLESALE: 'Tot. wholesale',
          PRODUCT_NUMBER: 'N° de productos',
          LAST_UPDATE: 'Última actualización',
          WITH_REQUESTER_NOTIFICATION: 'Con notificación del solicitante',
          LAST_UPDATE_REQUESTER: 'Última actualización del solicitante',
        },
      },

      SUPER_BULK: {
        COLUMN: {
          ID: 'Id',
          USER: 'Usuario',
          OPERATION_TYPE: 'Tipo de operación',
          CREATION_TIME: 'Fecha de creación',
          START_AT: 'Inicia el',
          CONCLUDED_AT: 'Concluye el',
          STATUS: 'Estado',
        },
        OPERATION_TYPE: {
          UPDATING_VISIBILITY_PRE: 'Actualizando visibilidad pre-order',
          UPDATING_VISIBILITY_RE: 'Actualizando visibilidad re-order',
          UPDATING_PRICE: 'Actualizando precio',
          UPDATING_BLANK_CELL: 'Actualizando celda en blanco',
          ASSOCIATING_TIER: 'Asociando tier',
          DISASSOCIATING_TIER: 'Desasociando tier',
          ASSOCIATING_ASSORTMENT: 'Asociación de asortamiento',
          DISASSOCIATING_ASSORTMENT: 'Desasociación de asortamiento',
          ASSOCIATING_PROMOTION: 'Asociando promoción',
          DISASSOCIATING_PROMOTION: 'Desasociando promoción',
          UPDATE_PALETTES_STOCK_LIMITS: 'Actualizar límites de compra por color (para los canales que lo soportan)',
        }
      },

      BULK_OPERATIONS: {
        NAME: 'Operaciones',
        COLUMNS: {
          ID: 'Id',
          TYPE: 'Tipo',
          CREATOR: 'Creador',
          CREATED_AT: 'Fecha de creación',
          SCOPE: 'Alcance',
          STATUS: 'Estado',
          ISSUE: 'Problema',
          ORDER_ITEM_ID: 'ID artículo pedido',
          ORDER_ID: 'ID pedido',
          ORDER_NUMBER: 'Número de pedido',
          CUSTOMER_NAME: 'Nombre del cliente',
          CUSTOMER_ACCOUNT: 'Número de cuenta',
          STARTED_AT: 'Iniciado el',
          CONCLUDED_AT: 'Concluido el',
          PROCESSED_ORDER_ITEMS_COUNT: 'Artículos procesados',
          PROCESSED_WITH_ISSUES_COUNT: 'Artículos con problemas'
        },
      },
      BULK_EDIT_ORDERS_MODAL: {
        INFO_MESSAGE: 'Usando las casillas de verificación, puedes modificar varios elementos al mismo tiempo. Atención: al guardar, se guardarán todos los elementos de esta ventana, independientemente de la selección realizada.',
        ADD_NEW_ITEMS: 'Agregar nuevos articulos',
        REPLACE_ITEMS: 'Remplazar articulos',
        REMOVE_ITEMS: 'Eliminar articulos',
        CURRENT_DATE: 'Fecha actual',
        NEW_DATE: 'Nueva fecha',
        DISCOUNT: 'Descuento',
        CHANGE_ITEMS_DELIVERY_DATE: 'Cambiar fecha de entrega articulos',
        SUCCESS_CHANGE_ITEMS_DELIVERY_DATE: 'Fecha de entrega articulos modificada con exito',
        SUCCESS_ADD_ITEMS: 'Articulos agregados con exito',
        SUCCESS_CHANGE_ITEMS_WHOLESALE_PRICE: 'Precios actualizados con exito',
        INVALID_WHOLESALE_PRICE: 'El precio ingresado no es valido',
        CHANGE_CUSTOMER_AND_SHIPPING_ADDRESS: 'Cambiar cliente y direccion de envio',
        EDIT_QUANTITY: 'Editar cantidad',
        EDIT_WHOLESALE_PRICE: 'Editar precio ingrosses',
        WHOLESALE_PRICE: 'Precio al por mayor',
        CURRENT_UNIT_PRICE: 'Precio unitario actual',
        NEW_UNIT_PRICE: 'Nuevo precio',
        SUCCESS_REPLACE_ITEMS: 'Articulos remplazados con exito',
        SUCCESS_CHANGE_ITEMS_QUANTITY: 'Cantidad articulos modificada con exito',
        SUCCESS_DELETE_ITEMS: 'Articulos eliminados con exito',
        SUCCESS_OPERATION: 'Operación encolada con exito',
      },

      COMMERCIAL_AGREEMENT: {
        NAME: 'Acuerdos comerciales',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nombre',
          VALID_FROM: 'Válido desde',
          VALID_UNTIL: 'Válido hasta',
          DISCOUNT_PERCENTAGE: '% descuento',
          TOTAL_RETAIL_AMOUNT: 'Tot. retail (€)',
          RESIDUAL_RETAIL_AMOUNT: 'Tot. residual (€)',
          CUSTOMER_NAME: 'Nombre del cliente',
          STATUS: 'Estado',
          CONSUMPTION: 'Consumo',
        },
        MODAL_DELETE: {
          TITLE: 'Eliminar acuerdo comercial',
          MESSAGE: '¿Estás seguro de que quieres eliminar este acuerdo comercial?',
          ATTENTION_COMMERCIAL_AGREEMENT_IS_LINKED_ON_VARIOUS_CART: '<strong>¡Atención!</strong> Hay {{draftOrdersCount}} carritos vinculados a este acuerdo comercial. Al eliminar este acuerdo, también se eliminarán las asociaciones.',
        },
      },

      TERM_OF_SALE: {
        NAME: 'Términos de venta',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nombre',
          STATUS: 'Estado',
          CREATION_TIME: 'Fecha de creación',
          LAST_UPDATE_TIME: 'Última actualización',
        },
      },

      FULFILLMENT: {
        GROUP_ELEMENT: {
          SHIPPING_PACKAGE: 'Paquete',
          TOTAL_QUANTITY: 'Cantidad total',
          TOTAL_WEIGHT: 'Peso total',
        },
        COLUMNS: {
          STYLE: 'Estilo',
          COLOR: 'Color',
          SIZE: 'Talla',
          QUANTITY: 'Qty',
          AMOUNT: 'Importe',
          EAN: 'EAN',
          ORDER_ID: 'ID pedido',
        },
      },

      PROMOTION: {
        NAME: 'Promociónes',
        COLUMNS: {
          ID: 'ID',
          NAME: 'Nombre',
          VALID_FROM: 'Válido desde',
          VALID_TO: 'Válido hasta',
          TYPE: 'Tipo',
          VALID_ON: 'Valido',
        },
        MODAL_DELETE_PROMOTION: {
          ARE_YOU_SURE: '¿Estás seguro?',
          ARE_YOU_SURE_DELETE_PROMOTION: '¿Estás seguro de que quieres eliminar la promoción?',
        },
        INFO_ALLERT: 'Los descuentos automáticos que se establezcan no se habilitarán en los canales'
      },
      VOUCHERS: {
        NAME: 'Vouchers',
        COLUMNS: {
          ID: 'Id',
          CODE: 'Código',
          DESCRIPTION: 'Descripción',
          CONSTRAINT_TYPE: 'Restricción',
          AMOUNT: 'Monto',
          THRESHOLD: 'Límite',
          VALID_FROM: 'Válida desde',
          VALID_TO: 'Válida para',
          RESIDUAL_AMOUNT: 'Cantidad residual',
          STATUS: 'Estado'
        },
        MODAL_DELETE_VOUCHER: {
          ARE_YOU_SURE: 'Estas seguro?',
          ARE_YOU_SURE_DELETE_VOUCHER: 'Está seguro de que desea eliminar el cliente?',
          ARE_YOU_SURE_DELETE_CUSTOMER: 'Estás seguro de desvincular el voucher del cliente?',
        },
        INFO_ALLERT: 'Los vales que se configuren no estarán habilitados en los canales',
      },

      PRIVILEGES_CASH: {
        COLUMNS: {
          EXTERNAL_ID: 'ID',
          NAME: 'Nombre',
          INITIAL_AMOUNT_WITH_VAT: 'Monto inicial con IVA',
          RESIDUAL_AMOUNT_WITH_VAT: 'Monto residual con IVA',
          RESIDUAL_AMOUNT_WITHOUT_VAT: 'Monto residual sin IVA',
          VALID_FROM: 'Válido desde',
          VALID_TO: 'Válido hasta',
          STATUS: 'Estado',
        },
        STATUS: {
          IMPORTABLE: 'Importable',
          ALREADY_IMPORTED: 'Ya importado',
        },
      },

      DISCOUNT: {
        NAME: 'Descuentos',
      },

      CART: {
        NAME: 'Carrito',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nombre',
          VARIANTS: 'Variantes',
          POS: 'Punto de venta',
          TOTAL: 'Total',
          TOTAL_RETAIL: 'Total retail',
          DATE: 'Fecha',
          TYPE: 'Tipo',
          AGENCY_CODE: 'Agencia',
          CHANNEL_NAME: 'Canal',
          PCS: 'Pcs',
          SEASON_REFERENCE: 'Season reference',
          NOTE: 'Notas',
          EXTERNAL_ID: 'External ID',
        },
        ASTERISK_MESSAGE: 'Totales calculados sobre precios de venta al público por pertenecer a los canales',
        MISSING_EXCEL_FILE_MESSAGE: 'Para continuar, debe cargar un archivo Excel',
        MISSING_EXCE_CODE_MESSAGE: 'Seleccione un tipo de código para poder descargar el modelo',
        UPLOAD_DONE: '¡Operación iniciada con éxito! Recibirás un correo electrónico con el resultado de la operación.',
        MODAL_IMPORT: {
          IMPORT_CART_FROM_FILE_XLSX: 'Importar carrito desde archivo XLSX',
          CART_REPORT_UPLOADED: 'El reporte de carrito ha sido subido',
          CUSTOMER: 'Cliente',
          POINT_OF_SALE: 'Punto de venta',
          CART_NAME: 'Nombre del carrito',
          TYPE: 'Tipo',
          ALTERNATIVE_SHIPPING_ADDRESS: 'Dirección de envío alternativa',
          PRODUCT: 'Producto',
          AGENCY: 'Agency'
        },
        MODAL_DUPLICATE_CART: {
          DUPLICATE_CART: 'Duplicar carrito',
          DUPLICATE: 'Duplicar',
        },
        MODAL_DELETE_CART: {
          ARE_YOU_SURE: '¿Estás seguro?',
          ARE_YOU_SURE_DELETE_CART: '¿Estás seguro de que quieres eliminar el carrito?',
        }
      },

      ADMIN_DOWNLOADS: {
        NAME: 'Descargas administrativas',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nombre',
          EXTENTION: 'Tipo',
          UPLOAD_DATE: 'Fecha de subida',
          CREATOR: 'Creador',
        },
        ACTION: {
          DOWNLOAD: 'Descargar',
          DELETE: 'Eliminar',
          UPLOAD_FILE: 'Subir archivo',
        },
        MODAL_DELETE_FILE: {
          ARE_YOU_SURE: '¿Estás seguro?',
          ARE_YOU_SURE_DELETE_FILE: '¿Estás seguro de que quieres eliminar este archivo?',
        },
      },

      ORDER: {
        NAME: 'Pedido',
        COLUMNS: {
          STATUS: 'Estado',
          PENDING_BULK: 'Bulk pendiente',
          POINTS_OF_SALES: 'Puntos de venta',
          AGENCY_CODE: 'Código de agencia',
          CUSTOMER: 'Cliente',
          GOK: 'GOK',
          REASSORTMENT: 'Re surtido',
          PRODUCT_EXCHANGE: 'Intercambio de productos'
        }
      },

      ASSORTMENTS: {
        NAME: 'Asortamientos',
        COLUMNS: {
          ID: 'Id',
          TITLE: 'Título',
          CHANNEL_NAME: 'Canal',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
        }
      },

      VARIANT_BULK_EDITOR: {
        NAME: 'Editor variantes',
        INCLUDE_BY: 'Seleccionar por: ',
        INCLUDE_BY_ASSORTMENT: 'Asortamiento',
        INCLUDE_BY_COLLECTION: 'Colección',
        INCLUDE_BY_TIER: 'Tier',
        SELECTED: 'Seleccionado',
        EDIT_SELECTED: 'Editar seleccionado',
        DESELECT_ALL: 'Deseleccionar todo',
        YOU_HAVE_JUST_SELECTED: 'Acabas de seleccionar',
        NEW_VARIANTS_FROM_ASSORTMENT: 'nuevas variantes de asortamiento',
        NEW_VARIANTS_FROM_COLLECTION: 'nuevas variantes de colección',
        NEW_VARIANTS_FROM_TIER: 'nuevas variantes de tier',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_ASSORTMENT: 'Puedes seleccionar todas las variantes de un asortamiento dado',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_COLLECTION: 'Puedes seleccionar todas las variantes de una colección dada',
        YOU_CAN_SELECT_ALL_VARIANT_OF_A_GIVEN_TIER: 'Puedes seleccionar todas las variantes de un tier dada',
        NO_ASSORTMENT_TO_VIEW: 'No hay asortamientos para ver',
        NO_COLLECTION_TO_VIEW: 'No hay colección para ver',
        NO_SELECTED_VARIANTS: 'No hay variantes seleccionadas',
        ORDERS_FROM_LIST: 'Pedidos de la lista',
        CONFIRM_LEAVE_PAGE: {
          ARE_YOUR_SURE: '¿Estás seguro?',
          IF_YUO_LEAVE_PAGE_YOU_WILL_LOSE_ALL_CHANGES: 'Si dejas esta página perderás todos los cambios',
        },
        UNPUBLISH_ALL_FOR_PRE_ORDER: 'Despublicar todo para pre-order',
        ARE_YOU_SURE: '¿Estás seguro?',
        ARE_YOU_SURE_UNPUBLISH_ALL_VARIANTS_FROM_PRE_ORDER: '¿Estás seguro de que quieres despublicar todas las variantes de pre-order?',
        UNPUBLISH_ALL_FOR_PRE_ORDER_WARNING: 'Esta acción se aplicará a todos los productos',
        MESSAGE_SUCCESS_UNPUBLISH: 'Todas las variantes de pre-order han sido despublicadas',
        MESSAGE_SUCCESS_SEND_EMAIL: 'El reporte de variantes pre-order ha sido enviado con éxito',
        DOWNLOAD_REPORT_VARIANTS_ON_PRE_ORDER: 'Descargar reporte de variantes pre-order',
        DOWNLOAD_REPORT_VARIANTS_ON_RE_ORDER: 'Descargar reporte de variantes re-order',
        DOWNLOAD_REPORT_VARIANTS: 'Descargar reporte de variantes',
        ARE_YOU_SURE_DELETE_ORDERS: '¿Estás seguro de que quieres eliminar este nivel?',
      },

      TIERS: {
        NAME: 'Tiers',
        CREATE_MODAL: {
          ADD_NEW_TIER: 'Añadir nuevo nivel',
          EDIT_TIER: 'Editar nivel',
          NAME: 'Nombre',
          DESCRIPTION: 'Descripción',
        },
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nombre',
          DESCRIPTION: 'Descripción',
          CREATED_ON: 'Creado el',
          CREATED_BY: 'Creado par',
        },
        DELETE_MODAL: {
          TITLE: '¿Está seguro ?',
          DESCRIPTION: '¿Está seguro de que desea borrar este nivel?',
        },
        ARCHIVE_MODAL_DESCRIPTION: '¿Está seguro de que desea archivar este nivel? La operación no es reversible.'
      },

      SEASON_REFERENCE: {
        NAME: 'Season Reference',
        CREATE_EDIT: {
          NAME: 'Nombre',
          DATE_FROM: 'Válido a partir de',
          DATE_TO: 'Válido hasta el',
        },
        TABLE: {
          ID: 'Id externo',
          NAME: 'Nombre',
          DATE_FROM: 'Válido a partir de',
          DATE_TO: 'Válido hasta el',
        },
        CREATE_OR_EDIT: {
          CREATE_NEW: 'Crear nuevo',
          EDIT: 'Modificación',
          CANCEL: 'Cancelar',
          SAVE: 'Salvar',
        },
        DELETE_MODAL: {
          DELETE_SR: 'Cancelar season reference',
          SURE: '¿Quieres borrar este sr?',
          DELETE: 'Borrar'
        }
      },

      SHOWCASES: {
        NAME: 'Showcases',
        CREATE_EDIT: {
          NAME: 'Nombre',
          DATE_FROM: 'Válido desde',
          DATE_TO: 'Válido hasta',
        },
        TABLE: {
          NAME: 'Nombre',
          STATUS: 'Estado',
          ACTIVE: 'Activo',
          INACTIVO: 'Inactivo'
        },
        CREATE_OR_EDIT: {
          CREATE_NEW: 'Crear nuevo',
          EDIT: 'Editar',
          CANCEL: 'Cancelar',
          SAVE: 'Guardar',
        },
        AUTOMATIC_DISCOUNTS: {
          TITLE: 'Añadir descuento automático',
          ARE_YOU_SURE: '¿Seguro que desea eliminar el escaparate del descuento automático?',
          ALREADY_ADDED_TITLE: 'Ya añadido',
          ALREADY_ADDED: 'Este escaparate ya está asociado a este Descuento Automático',
        },
        ASSORTMENTS: {
          TITLE: 'Añadir surtido',
          ARE_YOU_SURE: '¿Está seguro de que desea eliminar este escaparate del surtido?',
          ALREADY_ADDED: 'El escaparate ya está asociado a este Surtido.'
        },
        DESCRIPTION: {
          NAME: 'Seleccione el Escaparate para el que está disponible el surtido:'
        },
        DELETE_MODAL: {
          DELETE_SR: 'Borrar Escaparate',
          SURE: '¿Desea eliminar este Escaparate?',
          DELETE: 'Borrar'
        }
      },

      AGENCIES: {
        NAME: 'Agencia',
        CHANGE_AGENCY_ASSOCIATION: 'Asociación de agencias/puntos de venta de cambio',
        FROM_AGENCY: 'De la agencia',
        TO_AGENCY: 'A la agencia',
        MODAL_INFO: 'Aquí puedes mover masivamente los enlaces de todos los puntos de venta (y carros relativos) con una agencia a otra',
        COLUMNS: {
          VAT: 'IVA',
          ALTERNATIVE_VAT: 'TVA Alternativa',
          ALTERNATIVE_GLN: 'GLN Alternativa',
          AGENCY_CODE: 'Código',
          NAME: 'Nombre',
          CITY: 'Ciudad',
          ORDERS_YTD: 'Pedidos (YTD)',
          TOTAL_YTD: 'Total (YTD)',
          STATUS: 'Estado',
          RELOAD_PAGE: 'Recargar página',
        },
        MODAL_DELETE_AGENCY: {
          ARE_YOU_SURE: '¿Estás seguro?',
          ARE_YOU_SURE_DELETE_AGENCY: '¿Estás seguro de que quieres eliminar la agencia?',
        },
        POS_UPDATE: 'Puntos de venta actualizados: ',
        CARTS_UPDATE: 'Carritos actualizados: '
      },

      CUSTOMERS: {
        NAME: 'Cliente',
        COLUMNS: {
          VAT: 'NIF',
          NAME: 'Nombre',
          CITY: 'Ciudad',
          POS: 'Punto de venta',
          POS_PLURAL: 'Puntos de venta',
          ORDERS_YTD: 'Pedidos (YTD)',
          TOTAL_YTD: 'Total (YTD)',
          STATUS: 'Estado',
          RELOAD_PAGE: 'Recargar página',
        },
        INFO_SECTION: {
          INFO: 'Información del Cliente',
          COMMERCIAL_INFO: 'Información Comercial',
          FINANCIAL_INFO: 'Información Financiera',
          CUSTOMER_CLASSIFICATION: 'Clasificación del Cliente',
          TAX_COMPLIANCE: 'Fiscalidad y Cumplimiento',
          PREFIX_VAT: 'Prefijo del IVA',
          MISSING_POS_NAME: 'Nombre faltante en al menos un punto de venta',
          VAT_WITHOUT_PREFIX: 'IVA sin Prefijo',
          DEFAULT_TRANSACTION_SPECIFICATION: 'Especificación Transacción Predeterminada',
          TRANSACTION_TYPE: 'Tipo de Transacción',
          IBAN: 'IBAN',
          SWIFT_CODE: 'Código SWIFT',
          BANK_NAME: 'Nombre del Banco',
          BANK_ACCOUNT_NUMBER: 'Número de Cuenta Bancaria',
          BANK_ACCOUNT_ID: 'ID de Cuenta Bancaria',
          ROUTING_NUMBER: 'Routing number',
          ROUTING_TYPE: 'Routing type',
          FISCAL_CODE: 'Código Fiscal',
          ABI: 'ABI',
          CAB: 'CAB',
          BANKING_DETAILS: 'Detalles Bancarios',
          SAVE_ERP: 'Guardar y Enviar al ERP',
          BUSINESS_INFO: 'Información Empresarial',
          ACCOUNT_NUMBER: 'Número de Cuenta',
          GENERATE: 'Generar auto',
          ACCOUNT_NUMBER_USED: '¡Número de cuenta ya en uso!',
          VAT_ALREADY_USED: '¡VAT ya en uso!',
          EMAIL_ALREADY_USED: 'Email ya en uso!',
          CUSTOMERS_GROUP: 'Grupo de Clientes',
          SALES_TAX_GROUP: 'Grupo de Impuestos sobre Ventas',
          COMPANY_NAME: 'Nombre de la Empresa',
          PAYMENT_METHOD_CODE: 'Código de Método de Pago',
          LOGISTICS_TRANSACTIONS: 'Logística y Transacciones',
          PACKAGE_GROUPING_MODE: 'Modo de Agrupación de Paquetes',
          DELIVERY_TERMS: 'Términos de Entrega',
          CURRENCY_CODE: 'Código de Moneda',
          ADMINISTRATIVEEMAIL_MISSING: 'Detalles de contacto: Falta el correo administrativo',
          PHONE_MISSING: 'Detalles de contacto: Falta el teléfono',
          MOBILE_MISSING: 'Detalles de contacto: Falta el móvil',
          FAX_MISSING: 'Detalles de contacto: Falta el fax',
          EMAIL_MISSING: 'Detalles de contacto: Falta el correo electrónico',
          COMMERCIALEMAIL_MISSING: 'Detalles de contacto: Falta el correo comercial',
          PEC_MISING: 'Detalles de contacto: Falta el PEC',
          WEBSITE_MISSING: 'Detalles de contacto: Falta el sitio web',
          FACEBOOK_MISSING: 'Detalles de contacto: Falta Facebook',
          INSTAGRAM_MISSING: 'Detalles de contacto: Falta Instagram',
          TWITTER_MISSING: 'Detalles de contacto: Falta Twitter',
          LINKEDIN_MISSING: 'Detalles de contacto: Falta LinkedIn',
          MISSING_USER: 'Cree un usuario o introduzca uno existente',
          MISSING_CONTACTS_POS: 'Faltan datos de contacto en el punto de venta',
          MISSING_CONTACTS_POS_FRANCE: 'Introduzca al menos un correo electrónico administrativo',
          MISSING_LOCATION_POS: 'Faltan datos de dirección en el punto de venta',
          MISSING_CHANNELS_IN_DROPDOWN: 'Para cada punto de venta, activa al menos una tienda e introduce al menos un canal de ventas para cada tienda activa',
          MISSING_ONLINESTORES_POS: 'Faltan datos de tienda online en el punto de venta',
          TOOLTIP_TAX_COMPLIANCE: 'Introduzca un número de IVA válido y único',
          TOOLTIP_COMPANY_OWNER: 'Es necesario crear/seleccionar un usuario',
          NOT_POSSIBLE_SAVE: 'No se puede guardar',
          SAVE_CHANGES: '¿Quieres guardar los cambios?',
          SUBJECTED_FACTORING: 'Factor',
          CREDIT_LIMIT: 'Credit limit',
          PAYMENT_TERMS_CODE: 'Código de Condiciones de Pago',
          PAYMENT: 'Pago',
          SDI_CODE: 'Código SDI',
          OFFICE_PA_CODE: 'Código de Oficina de la Administración Pública',
          PEC_EMAIL: 'Correo Electrónico PEC',
          CENTRAL_OF_PAYMENT: 'Cuenta del centro de pagos',
          CENTRAL_OF_PAYMENT_NUMBER: 'Número del centro de pagos',
          INVOICING_ACCOUNT_NUMBER: 'Cuenta de facturación',
          COMPANY_FORM: 'Forma Jurídica de la Empresa',
          KNOWN_AS: 'Conocido Como',
          GROUP_REPS: 'Grupo de Representantes',
          SWITCH_1: 'Este cliente puede ser asignado como "Cuenta de facturación" para otros clientes',
          SWITCH_2: 'Este cliente puede ser asignado como "Cuenta del centro de pagos" para otros clientes',
          BILLING_LOCATION: 'Dirección de Facturación',
          ADDRESS: 'Dirección',
          ALTERNATIVE_ADDRESS: 'Dirección Alternativa',
          PROVINCE: 'Provincia',
          POSTAL_CODE: 'Código Postal',
          CITY: 'Ciudad',
          COUNTRY: 'País',
          COMPANY_IDENTIFICATION: 'Identificación de la Empresa',
          SIREN_NUMBER: 'Número SIREN',
          SIRET_NUMBER: 'Número SIRET',
          GLN_NUMBER: 'Número de Cliente GLN',
          TOOLTIP_DETAIL_CONTACTS: 'Introduzca al menos un contacto por cada tipo enumerado a continuación',
          CONTACTS_DETAIL: 'Detalle de Contactos',
          ADMINISTRATIVE: 'Administrativo',
          TYPE: 'Tipo',
          VALUE: 'Valor',
          ANALYTICS: 'Análisis',
          CLASSIFICATION_GROUP: 'Grupo de Clasificación del Cliente',
          GROUP_CODE: 'Código de Grupo de Cliente',
          SUB_CODE: 'Código de Subgrupo de Cliente',
          SINGBOARD: 'Cartel del Cliente',
          HOLDING: 'Grupo Empresarial del Cliente',
          MISSING_FIELDS: 'Los siguientes campos no están rellenados',
          MISSING_FIELDS_TOOLTIP: 'No se puede enviar al ERP porque los siguientes campos no están completos:',
          MISSING_FIELDS_EMPTY: 'Es posible enviar al ERP, todos los campos obligatorios han sido completados ✅',
          ALREADY_SENT: '✅ Cliente ya enviado, no hay modificaciones',
          SELECT_COUNTRY: "Seleccione un país",
          ADD_LOCATION_BEFORE_CONTACTS: "Complete y guarde la sección <strong>\"Dirección de Facturación\"</strong> antes de agregar los contactos"
        },
        SUMMARY: {
          ORDER_INSIGHTS: 'Información sobre compras',
          CARTS_ORDERS_PLACED: 'Pedidos y carros realizados'
        },
        GOK: {
          NEW_GOK: 'Nuevo Gok',
          EDIT_GOK: 'Editar Gok',
          NAME: 'Nombre',
          TOTAL_AMOUNT: 'Importe total',
          DISACTIVE: 'Inactivo',
          EMAIL: 'Correo electrónico de contacto con Gok',
          MODIFY_EMAIL: 'Editar Email',
          VALID_FROM: 'Válido desde',
          VALID_TO: 'Válido hasta',
          RESIDUAL: 'Residual',
          ORIGINAL_AMOUNT: 'Importe original',
          STATUS: 'Estado',
          TITLE_MODAL: 'Borrar Gok',
          MESSAGE: '¿Seguro que quieres borrar este Gok?',
          CANT_ELIMINATE: 'No es posible borrar/modificar este Gok porque ya ha sido utilizado',
          IMPOSSIBLE: 'No es posible crear el Gok',
          DATE_RANGE: 'El Gok ya existe en este rango de fechas',
          ACTIVATE_GOK: 'Gok activo',
          MODIFY_GOK_NUMBER: 'Modificar número Gok',
          NUMBER: 'Número Gok',
          ADD_GOK_NUMBER: 'Agrega un número gok para activar su creación'
        },
        ATTACHMENTS: {
          TITLE: 'Adjuntos',
          NAME: 'Nombre',
          CODE: 'Código',
          COMMENTS: 'Comentarios',
          CREATION_TIME: 'Fecha de creación',
          TITLE_MODAL: 'Eliminar adjuntos',
          MESSAGE: '¿Estás seguro de que deseas eliminar este adjunto?',
          VIEW_ATTACHMENTS: 'Ver adjuntos',
        },
        COMMERCIAL_BLOCK: {
          TITLE: 'Bloqueo comercial del cliente',
          DESCRIPTION: 'Al activar el bloqueo comercial en el cliente, nadie excepto los usuarios con los roles StoreOwner, StoreUser y Admin podrá confirmar el carrito.',
          RESTRICTION_CAUSE: 'Causa de restricción',
          BLOCK_USER: 'Bloquear usuario',
        },
        ADJUNTOS: {
          TITLE: 'Archivos adjuntos',
          NAME: 'Nombre',
          CODE: 'Código',
          COMENTARIOS: 'Comentarios',
          CREATION_TIME: 'Fecha de creación',
          TITLE_MODAL: 'Eliminar archivos adjuntos',
          MESSAGE: '¿Seguro que quieres borrar este Adjunto?',
        },
        BLOQUE_COMERCIAL: {
          TITLE: 'Bloque comercial de cliente',
          DESCRIPTION: 'Al activar el bloqueo comercial en el cliente, nadie excepto los usuarios con los roles StoreOwner, StoreUser y Admin podrán confirmar el carrito de la compra',
          RESTRICTION_CAUSE: 'Causa de la restricción',
          BLOCK_USER: 'Usuario Bloqueado',
        },
        MODAL_DELETE_CUSTOMER: {
          ARE_YOU_SURE: '¿Estás seguro?',
          ARE_YOU_SURE_DELETE_CUSTOMER: '¿Estás seguro de que quieres eliminar el cliente?',
        },
        MODAL_IMPORT_CUSTOMER: 'Importar cliente por Id Post Office',
        CREATE_CUSTOMER: 'Crear cliente'
      },

      USERS: {
        NAME: 'Usuario',
        COLUMNS: {
          NAME: 'Nombre',
          EMAIL: 'Email',
          ROLE: 'Rol',
          COMPANY: 'Empresa',
          TYPE: 'Tipo',
          STATUS: 'Estado',
          GOK_NUMBER: 'Número Gok',
        }
      },

      LOCATION: {
        NAME: 'Ubicación',
        PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: 'Por favor, rellena todos los campos obligatorios',
        PLEASE_FILL_IN_ALL_STOCK_LIMIT_FIELDS: 'Por favor, rellena todos los campos de límite de stock',
        PLEASE_ENABLE_AT_LEAST_ONE_STORE_AND_ITS_CHANNEL: 'Por favor, activa al menos una tienda y su canal',
        PLEASE_ENABLE_AT_LEAST_ONE_CHANNEL: 'Selecciona al menos un canal de ventas para cada tienda habilitada',
        POINT_OF_SALE: 'Punto de venta',
        SHIPPING_LOCATION: 'Ubicación de envío',
        CREATE_MODAL: {
          CREATE_NEW_POINT_OF_SALE: 'Crear nuevo punto de venta',
          CREATE_NEW_SHIPPING_ADDRESS: 'Crear nueva dirección de envío',
        },
        COLUMNS: {
          NAME: 'Nombre',
          CITY: 'Ciudad',
          STORES: 'Tiendas',
          ORDERS_YTD: 'Pedidos (YTD)',
          TOTAL_YTD: 'Total (YTD)',
          COUNTRY: 'País',
          ADDRESS: 'Dirección',
        },
        MODAL_DELETE_POS: {
          ARE_YOU_SURE: '¿Estás seguro?',
          ARE_YOU_SURE_DELETE_POINT_OF_SALE: '¿Estás seguro de que quieres eliminar el punto de venta?',
        },
        MODAL_DELETE_SA: {
          ARE_YOU_SURE: '¿Estás seguro?',
          ARE_YOU_SURE_DELETE_SHIPPING_ADDRESS: '¿Estás seguro de que quieres eliminar la dirección de envío?',
        },
      },

      PRODUCT_LIST: {
        NAME: 'Lista de productos',
        COLUMNS: {
          STYLE: 'Estilo',
          NAME: 'Nombre',
          WHOLE_SALE: 'Pre-order wholesale',
          RETAIL: 'Pre-order retail',
          ALL_IMAGES_HIDDEN: 'Imágenes ocultas',
          STOCK: 'Stock',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
        },
        PRICE: 'Precio',
        VARIANTS: 'Variantes',
        INCLUDED: 'Incluido',
        SELECTED: 'seleccionadas',
        BY_PRODS: 'Por productos',
        BY_DATE: 'Por fecha',
      },

      VARIANT: {
        COLUMNS: {
          SKU: 'SKU',
          SIZE: 'Talla',
          COLOR: 'Color',
          STOCK_QTY: 'Stock (q.ty)',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
          STOCK_LIMIT: 'Límite stock',
        },
      },
      SALES_CAMPAIGNS: {
        COLUMNS: {
          NAME: 'Nombre',
          DESCRIPTION: 'Descripción',
          START_DATE: 'Fecha de inicio',
          END_DATE: 'Fecha de finalización',
          SHOP_SELLING_PERIOD_START: 'Inicio de ventas en la tienda',
          SHOP_SELLING_PERIOD_END: 'Inicio de ventas en la tienda',
          DELIVERY_PERIOD_START: 'Inicio de entrega',
          DELIVERY_PERIOD_END: 'Finalización de la entrega'
        },
        CREATE_MODAL: {
          EDIT_SALE_CAMPAIGN: 'Editar campaña de ventas',
          ADD_NEW_SALE_CAMPAIGN: 'Agregar campaña de ventas'
        },
        DELETE_MODAL: {
          TITLE: 'Estás seguro?',
          DESCRIPTION: 'Está seguro de que desea eliminar esta campaña de ventas?'
        },
        RULE: {
          COLUMN: {
            ID: 'Id',
            NAME: 'Nombre',
            ROLES_BYPASSING: 'Roles que omiten la regla',
            TIER: 'Tier',
            LAST_MODIFICATION_TIME: 'Última modificación',
            STATUS: 'Estado',
          },
        },
      },
      REPORTS: {
        NAME: 'Reports',
        COLUMNS: {
          ID: 'Id',
          NAME: 'Nombre',
          TYPE: 'Tipo',
          CREATOR: 'Creador',
          COMPLETED_AT: 'Completado el',
        },
      },
    },
    SALES_CAMPAIGNS: {
      NAME: 'Nombre',
      VALIDITY: 'Validez',
      COMMERCIAL_RULES: 'Reglas comerciales',
      NEW_RULE: 'Nueva regla',
      DELETE_ASSORTMENT_SUCCESSFULLY: 'Asortamiento eliminado con éxito',
      DELETE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Restricción de paquetes se eliminó con éxito',
      CREATE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Restricción de paquete creada con éxito',
      UPDATE_CONSTRAINT_PACKAGE_SUCCESSFULLY: 'Restricción de paquete actualizada con éxito',
      ENABLED_CONSTRAINT_VALUE_SUCCESSFULLY: 'Restricción de valor habilitada con éxito',
      DELETE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Restricción de valor eliminada con éxito',
      CREATE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Restricción de valor creada con éxito',
      UPDATE_CONSTRAINT_VALUE_SUCCESSFULLY: 'Restricción de valor actualizada con éxito',
      DELETE_FILTER_SUCCESSFULLY: 'Filtro eliminado con éxito',
      CREATE_FILTER_SUCCESSFULLY: 'Filtro creado con éxito',
      UPDATE_FILTER_SUCCESSFULLY: 'Filtro actualizado con éxito',
      UPDATE_RULE_SUCCESSFULLY: 'Regla actualizada con éxito',

      RULES: {
        CONSTRAINT_VALUE_NOT_ENABLED: 'La restricción no se puede habilitar para este surtido porque ya está activa en otro surtido.',
        CONSTRAINT_VALUE_INFO_MESSAGE: 'Esta restricción se desencadenará en cada carrito ligado a esta regla comercial.',
        CONSTRAINT_VALUE_ENABLED: 'Restricción valor habilitada',
        NO_ASSORTMENTS: 'No hay surtido configurado, agregue un surtido para gestionar las restricciones',
        NO_CONSTRAINT_PACKAGE: 'Aún no has ingresado ninguna restricción de paquete en este surtido',
        NO_CONSTRAINT_VALUE: 'Active esta funcionalidad para insertar la restricción de valor en este surtido',
        NO_CONSTRAINT_FILTER: 'Puedes configurar filtros para determinar los artículos con los que calcular el total mayorista',
        CONSTRAINTS_CONFIGURATION: 'Configuración de restricciones',
        TITLE: 'Reglas',
        RULE: 'Regla: {{ruleName}}',
        NAME: 'Nombre',
        TIER: 'Tier',
        ROLES_BYPASSING: 'Roles que omiten la regla',
        ADD_ASSORTMENT: 'Agregar asortamiento',
        ADD_CONSTRAINT: 'Agregar restricción',
        ADD_RULE: 'Agregar regla',
        CONSTRAINTS_PACKAGE: 'Paquete de restricciones',
        QUANTITY: 'Cantidad',
        STYLES_CODE: 'Productos',
        CONSTRAINT_VALUE: 'Valor de restricción',
        PERCENTAGE: 'Porcentaje',
        TYPE: 'Tipo',
        CONDITION: 'Condición',
        VALUE: 'Valor',
        VALUE_RULE_WHEN_CALCULATE_TOTAL_WHOLESALE_INFORMATION: 'El valor mayorista de los artículos pertenecientes a este surtido, respecto al total mayorista del carrito, deberá ser mayor o igual a:',
        VALUE_RULE_INFORMATION: 'Filtros para determinar los artículos del pedido sobre los que evaluar la restricción de valor:',
        ADD_OR_REMOVE: 'Agregar o eliminar',
        ADD_FILTER: 'Agregar filtro',
        ACTIVATE: 'Activar regla',
        DISABLE: 'Desactivar regla'
      },
      TYPE: {
        WHERE_STYLE_GROUP: 'Donde style group',
        WHERE_SIZE_GROUP: 'Donde size group',
      },
      CONDITION: {
        IS: 'es',
        IS_NOT: 'no es',
      },
    },
    PICK_LIST: {
      TO_INCLUDE: 'Para incluir',
      INCLUDED: 'Incluido',
      VARIANTS_SELECTED: 'Variantes seleccionadas: {{quantity}}',
      ALL: 'todo',
      SELECTED_ALL: 'Todo seleccionado',
      CLICK_FOR_OPEN_REPORT: 'Haga clic para abrir el informe',
      INCLUDE: 'Incluir',
      EXCLUDE: 'Excluir',
      VARIANTS: 'Variantes {{quantity}}',
      SUCCESS_VARIANTS_DISASSOCIATE: '{{quantity}} variantes desasociadas con éxito',
      SUCCESS_VARIANTS_ASSOCIATE: '{{quantity}} variantes asociadas con éxito',
      NO_OTHER_DATA: 'No hay otros datos',
      NO_DATA_FOUND: 'No se encontraron datos',
      SELECT_ALL_MODAL: {
        TITLE: 'Seleccionar todo',
        MESSAGE: '<strong>¡Advertencia!</strong> Al seleccionar este modo, se seleccionarán todos los productos y variantes disponibles para los filtros seleccionados. <br> Todavía puede excluir productos y variantes de la lista de selección.',
        NOT_SHOW_AGAIN: 'No mostrar de nuevo',
        CONFIRM: 'Confirmar',
      },
      SELECT_ALL_CANCELED: 'Selección de todos cancelada',
      REPORT_SELECTED_MODAL: {
        TITLE: 'Informe de selección',
        NOT_SELECTED: 'Aún no se ha seleccionado ninguna variante o color de producto',
        YOU_ARE_SELECTING: 'Estás seleccionando {{quantity}} {{what}}',
        YOU_ARE_EXCLUDING: 'excluyendo {{quantity}} {{what}}',
        PRODUCT_STYLE_COLOR: 'producto-color',
        VARIANTS: 'variantes',
        YOU_ARE_SELECTING_ALL_VARIANTS_FOR_THIS_FILTERS: 'Estás seleccionando todas las variantes para estos filtros',
        YOU_ARE_SELECTING_THE_ENTIRE_CATALOGUE_AVAILABLE: 'Estás seleccionando todo el catálogo disponible',
        FROM_THE_SELECTION_YOU_ARE: 'De la selección estás',
        EXCLUDING_PRODUCTS_STYLE_COLOR: 'excluyendo {{quantity}} productos-color',
        EXCLUDING_VARIANTS: 'excluyendo {{quantity}} variantes',
        NOT_VARIANT_OR_PRODUCT_STYLE_COLOR_HAS_BEEN_SELECTED_YET: 'Aún no se ha seleccionado ninguna variante o color de producto',

      },
      SAVE_INCLUDE_EXCLUDE_MODAL: {
        ARE_YOU_SURE: '¿Estás seguro?',
      }
    },
    COMMERCIAL_AGREEMENT_DETAIL: {
      CONTINUE_WITHOUT_COMMERCIALAGREEMENT: "Continúa sin selección",
      BACK_TO_COMMERCIAL_AGREEMENTS: 'Volver a acuerdos comerciales',
      CREATE_NEW_COMMERCIAL_AGREEMENT: 'Crear nuevo acuerdo comercial',
      COMMERCIAL_AGREEMENT: 'Acuerdo comercial: {name}',
      COMMERCIAL_AGREEMENT_INFO: 'Información del acuerdo comercial',
      NAME: 'Nombre',
      VALID_FROM: 'Valido desde',
      VALID_UNTIL: 'Válido hasta',
      DISCOUNT_PERCENTAGE: '% descuento',
      TOTAL_RETAIL_AMOUNT: 'Techo (valor retail, €)',
      CUSTOMER: 'Cliente',
      CHANNEL: 'Canal',
      ERRORS: {
        COMPILE_ALL_REQUIRED_FIELDS: 'Por favor, rellena todos los campos obligatorios',
      },
    },
    TERM_OF_SALE_DETAIL: {
      BACK_TO_TERMS_OF_SALE: 'Volver a términos de venta',
      CREATE_NEW_TERM_OF_SALE: 'Crear nuevo término de venta',
      TERM_OF_SALE: 'Término de venta',
      NAME: 'Nombre',
      SET_AS_ACTIVE: 'Establecer como activo',
      TERMS_AN_CONDITIONS_BY_LANGUAGE: 'Términos y condiciones por idioma',
      PLEASE_SELECT_A_DEFAULT_LANGUAGE: 'Seleccione un idioma predeterminado utilizando el menú de acción junto al nombre del idioma seleccionado',
      PLEASE_WRITE_A_TERM_OF_SALE_FOR_THE_DEFAULT_LANGUAGE_OR_SELECT_ANOTHER_DEFAULT_LANGUAGE: 'Escribe un término de venta para el idioma de default o selecciona otro idioma de default',
      PLEASE_ENTER_A_VALID_TERM_OF_SALE_NAME: 'Por favor, introduce un nombre de término de venta válido',
      TERM_OF_SALE_UPDATE_SUCCESS: 'Término de venta actualizado con éxito',
      TERM_OF_SALE_CREATE_SUCCESS: 'Término de venta creado con éxito',
      NAME_ALREADY_EXISTS: 'El nombre ya existe',
      ENTER_THE_TERM_OF_SALE: 'Introduce el término de venta',
      NAME_REQUIRED: 'Nombre obligatorio',
      NAME_INVALID: 'Nombre inválido',
      TERM_OF_SALE_DELETE_SUCCESS: 'Término de venta eliminado con éxito',
      ARE_YOU_SURE: '¿Estás seguro?',
      ARE_YOU_SURE_DELETE_TERM_OF_SALE: '¿Estás seguro de que quieres eliminar el término de venta?',
      ERROR_IS_APPLIED_TO_ORDERS: 'Este término de venta no se puede cambiar ni eliminar ya que se ha asociado con uno o más pedidos',
    },
    TIER_DETAIL: {
      BACK_TO_TIERS: 'Volver a tiers',
      CREATE_NEW_TIER: 'Crear nuevo tier',
      NAME: 'Nombre',
      INFORMATION: 'Información',
      DESCRIPTION: 'Descripción',
      INCLUDE_VARIANTS: 'Incluir variantes',
      INCLUDED_VARIANTS: 'Variantes incluidas',
      ASSOCIATE_VARIANTS: 'Asociar variantes',
      DISASSOCIATE_VARIANTS: 'Desasociar variantes',
      PLEASE_FILL_ALL_REQUIRED_FIELDS: 'Por favor, rellena todos los campos obligatorios',
      TIER_UPDATE_SUCCESS: 'Tier actualizado correctamente',
      TIER_CREATE_SUCCESS: 'Tier creado correctamente',
      VARIANTS_DISASSOCIATED_SUCCESS: 'Variantes desasociadas correctamente',
      VARIANTS_ASSOCIATED_SUCCESS: 'Variantes asociadas correctamente',
      REMOVE_POS_FROM_TIER: '¿Estás seguro de que quieres eliminar el punto de venta del nivel?',
      POS_ALREADY_ASSOCIATED: 'Punto de venta ya asociado al nivel',
      OPTION_DESCRIPTION: 'Al activar esta opción, las tiendas con este tier asociado verán no solo las variantes de este tier, sino también aquellas que no tengan ningún tier asociado, para el canal de venta establecido.',
      INFO_ALLERT: {
        INCLUDE_VARIANTS: 'Seleccione las variantes para incluir en el nivel y luego haga clic en Guardar para actualizar el nivel.',
        INCLUDED_VARIANTS: 'Estas son las variantes incluidas en el nivel. Seleccione las variantes que desea eliminar por niveles y luego haga clic en Guardar para actualizar el nivel.',
      },
      DETAIL: 'Detalle',
      ASSOCIATED_VARIANTS: 'Variantes asociadas',
      ARCHIVED_TIER: 'Nivel archivado #{{tierName}}',
      WORK_IN_PROGRESS_MESSAGE: 'Aquí podrá ver las variantes asociadas con este nivel. Estamos trabajando para usted.',
      CHANNEL: 'Canal',
      ARE_YOU_SURE_SAVE_STORE_POINTS_OF_SALE: '¿Estás seguro de que quieres asociar los puntos de venta seleccionados al nivel actual?',
      SELECTED_STORE_POINTS_OF_SALE: 'Puntos de venta seleccionados',
      STORE_POINTS_OF_SALE_SAVED: 'Puntos de venta salvados con éxito',
    },
    LOCATION_DETAIL: {
      POINT_OF_SALE_INFO: 'Información del punto de venta',
      BACK_TO_POS: 'Volver a puntos de venta',
      ADDRESS_INFO: 'Información de la dirección',
      PURCHASE_STATS: {
        NAME: 'Estadísticas de compra',
        TOTAL_CUSTOMER_REVENUE: 'Ingresos totales de clientes',
        FROM_PRE_ORDER: 'Desde pre-order',
        FROM_RE_ORDER: 'Desde re-order',
        TOTAL_MARGIN: 'Margen total',
        TOTAL_ORDERS: 'Total de pedidos',
        AVERAGE_ORDER_VALUE: 'Valor medio de pedido',
      },
      SUMMER_STOCK_LIMIT: 'Límite de stock de verano',
      WINTER_STOCK_LIMIT: 'Límite de stock de invierno',
      SUMMER_START_MONTH: 'Mes de inicio de verano',
      WINTER_START_MONTH: 'Mes de inicio de invierno',
      SUMMER_START_DAY: 'Día de inicio de verano',
      WINTER_START_DAY: 'Día de inicio de invierno',
      STOCK_LIMIT: 'Límite de stock',
      THE_WAREHOUSE_LIMIT_MUST_BE_SET_FOR_THE_CHANNELS: 'El límite de stock del almacén debe establecerse para los canales',
      ONLINE_STORES_ENABLED: 'Tiendas en línea activadas',
      USE_NAME_IN_ORDER_HEADER: 'Use el nombre del punto de venta en el comprobante de pedido',
      BACK_TO_LOCATIONS: 'Volver a ubicaciones',
      NAME: 'Nombre',
      TIER: 'Nivel',
      AGENCY: 'Agencia',
      CHANNEL: 'Canal',
      YOU_CANT_EDITINFO_ABOUT_ADDRESS: '¡No puede editar la información sobre la dirección si está esperando la aprobación de una tienda!',
      YOU_CANT_ACTIVEATE_THIS_ADDRESS_IF_ITS_CUSTOMER_IS_NOT_APPROVED: '¡No puede activar esta dirección si el cliente no está aprobado!',
      MISSING_STOCK_LIMIT: '¡Atención! Para activar la dirección en el canal Plug&Sell, primero debes completar la sección de límites de stock.',
      ERROR_MODAL: {
        TITLE: 'Atención!',
        DESCRIPTION: 'Faltan campos para guardar cambios, datos completos para continuar',
      }
    },
    CONTACT: {
      NAME: 'Contacto',
      NEW_CONTACT: 'Nuevo contacto',
      EDIT_CONTACT: 'Editar contacto',
      CONTACT_INFO: 'Información del contacto',
    },
    USER_DETAIL: {
      USER_INFO: 'Información del usuario',
      REGISTERED_SINCE: 'Registrado desde',
      NAME_SURNAME: 'Nombre y apellido',
      NAME_SURNAME_ERROR: 'Nombre y apellido obligatorios',
      EMAIL_ERROR: 'Email obligatorio',
      ROLES_ERROR: 'Rol obligatorio',
      STORE_ERROR: 'Tienda obligatoria',
      CUSTOMER_ERROR: 'Cliente obligatorio',
      AGENCY_ERROR: 'Agencia obligatoria',
      USER_ROLE: 'Rol de usuario',
      AGENCY: 'Agencia',
      CUSTOMER: 'Cliente',
      BACK_TO_USERS: 'Volver a usuarios',
      MY_PROFILE: 'Mi perfil',
      INVITE_USER: 'Invitar usuario',
      SEND_INVIATION: 'Enviar invitación',
      USER_STATUS: 'Estado del usuario',
      RESEND_INVITATION: 'Reenviar invitación',
      INVITATION_RESENT_COMPLETED: 'Invitación reenviada con éxito',
      INVITATION_RESENT_ERROR: 'Error al reenviar invitación',
      MODAL_CONFIRM: {
        ARE_YOU_SURE: '¿Estás seguro?',
        ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_USER: '¿Estás seguro de que quieres desactivar este usuario?',
      }
    },
    WORK_IN_PROGRESS_TITLE: 'Estamos trabajando para usted: mantenimiento extraordinario a partir de las {{fromHour}} del {{fromDate}}. Volveremos en línea a las {{toHour}} del {{toDate}}',
    ORDER_DETAIL: {
      EXTRA_COSTS_INFO: 'Aquí puedes personalizar los costos de envío y/o personalización. Si no se establecen, los costos correspondientes se completarán según la configuración predeterminada. Por ejemplo, si no deseas cobrar los gastos de envío para este carrito, introduce 0 en el campo correspondiente.',
      CUSTOMIZATION_COSTS: 'Costos de personalización',
      MANAGE_EXTRA_COSTS: 'Gestionar costos extra',
      BULK_OPERATIONS_STATUS_SYNCING: 'Este pedido se está actualizando actualmente ({{processingCount}} operaciones en cola). Todas las operaciones están temporalmente deshabilitadas hasta que se complete la sincronización.',
      BULK_OPERATIONS_STATUS_SYNCING_2: 'Este pedido se está actualizando actualmente. Todas las operaciones están temporalmente deshabilitadas hasta que se complete la sincronización.',
      BULK_OPERATIONS_STATUS_AWATING: 'Este pedido tiene {{processingCount}} operaciones en espera en la cola.',
      HAS_OPERATION_PENDING_MESSAGE: '¡Lo sentimos! Este pedido ya no se puede modificar porque uno de los trabajos en cola ya ha comenzado. Vuelve a modificar el pedido cuando todos los trabajos en cola hayan finalizado y actualiza la página para ver los detalles.',
      STATS: {
        TOTAL_WHOLESALE: 'Total wholesale',
        TOTAL_RETAIL: 'Total retail',
        TOTAL_NET: 'Total neto',
        TOTAL_NET_IVA: 'Total neto (impuestos incluido)',
        VAT_MARKUP: 'RE',
        VAT: 'IVA',
        TOTAL_ORDERED: 'Total pedido',
        TOTAL_DISCOUNT: 'Descuento tot. al wholesale',
        TOTAL_PIECES: 'Piezas',
        TOTAL_MARGIN: 'Margen',
        TOTAL_COST: 'Coste',
        TOTAL_CUSTOMER_DISCOUNT: 'Descuento del cliente',
        TOTAL_COMMERCIAL_DISCOUNT: 'Descuento comercial',
        TOTAL_FINANCIAL_DISCOUNT: 'Descuento financiero',
        TOTAL_STORECHANNEL_DISCOUNT: 'Descuento de StoreChannel',
        TOTAL_AGREEMENT_DISCOUNT: 'Descuento del tr. com.',
        TOTAL_AUTO_DISCOUNT: 'Descuentos automáticos',
        TOTAL_VOUCHER_AMOUNT: 'Valor del voucher',
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Descuento de retail',
        DISCOUNT: 'Descuento',
        TOTAL_SERVICES: 'Total servicios',
        SHIPPING_COST: 'Coste envío',
        SOME_ORDERITEMS_HAS_NO_COST: 'Algunos artículos del carrito no tienen costo especificado, por lo tanto esta funcionalidad no está disponible',
        PENDING_OPERATION: 'No puedes realizar operaciones en el carrito ya que hay cargas de líneas de pedido mediante archivo Excel en proceso.',
        CHOOSE_EXCEL_PROPS_TITLE: 'Elige las propiedades',
        CHOOSE_EXCEL_PROPS: 'Elige las columnas a mostrar en la hoja de Excel dedicada a las líneas de pedido',
        CHOOSE_DOWNLOAD_TYPE: 'Elige el tipo de descarga',
        DOWNLOAD_TYPE_MESSAGE: 'Una vez finalizado el proceso, recibirás un correo electrónico con el archivo adjunto una vez disponible',
        CUSTOM_DATE: 'Fecha personalizada',
        EDIT_CUSTOM_DATE: 'Personalizar fecha',
        NO_CUSTOM_DATE: 'Fecha no personalizable',
        SELECTED_ITEMS: 'líneas de pedido seleccionadas',
        REQUESTED_SALES_PRICE: 'Precio de venta demandado',
        COLUMNS: {
          IMAGE: 'Imagen',
          NAME: 'Columnas',
          SKU: 'SKU',
          COLOR: 'Color',
          COLOR_CODE: 'Código de color',
          COLOR_NAME: 'Nombre del color',
          SIZE: 'Talla',
          UNIT_WHOLESALE: 'Unidad mayorista',
          UNIT_NET: 'Unidad neta',
          UNIT_COST: 'Costo por unidad',
          UNIT_MARGIN: 'Margen por unidad',
          TOTAL_RETAIL: 'Total minorista',
          TOTAL_WHOLESALE: 'Total mayorista',
          TOTAL_NET: 'Total neto',
          TOTAL_COST: 'Costo total',
          TOTAL_MARGIN: 'Margen total',
          TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Descuento del precio minorista',
          TOTAL_DISCOUNT_PERCENTAGE: 'Descuento del precio mayorista',
          CUSTOMER_DISCOUNT: 'Descuento para cliente',
          AGREEMENT_DISCOUNT: 'Descuento por acuerdo',
          FINANCIAL_DISCOUNT: 'Descuento financiero',
          STORECHANNEL_DISCOUNT: 'Descuento por canal de venta',
          DISCOUNT_BY_QTY: 'Descuento por cantidad',
          DISCOUNT_BY_VALUE: 'Descuento por valor',
          COMMERCIAL_DISCOUNT: 'Descuento comercial',
          MARGIN_PERCENTAGE: 'Porcentaje de margen',
          QTY: 'Cantidad',
          EAN: 'EAN',
          SIZE_GROUP: 'Grupo de tallas',
          PRODUCT_CODE: 'Código de producto',
          PRODUCT_TITLE: 'Nombre del producto',
          DATE: 'Fecha',
          ORDERED_QTY: 'Cantidad pedida',
          CANCELED_QTY: 'Cantidad cancelada',
          NOT_FULFILLED_QTY: 'Cantidad no cumplida',
          FULFILLED_QTY: 'Cantidad cumplida',
          FULFILLMENT_STATUS: 'Estado de cumplimiento',
          GROUP_GENERAL: 'General',
          GROUP_UNITARY: 'Unitario (€)',
          GROUP_TOTALS: 'Totales (€)',
          GROUP_PERCENT: 'Porcentajes (%)',
          GROUP_FULFILLMENT: 'Cumplimiento',
          STYLE_GROUP: 'Grupo de estilo',
          NOTE: 'Notas',
          VARIANT_CODE: 'Código de variante',
          DELIVERY_DATE: 'Fecha de entrega',
          REPLACE_EAN: 'Remplazar EAN',
          CANCELLATION_REASON: 'Motivo de cancelación',
        },
      },
      UPLOADS: {
        UPLOADED: '¡Carga de archivos completada! Un correo electrónico le avisará de la finalización de la operación.',
        TITLE: 'Uploads',
        MESSAGE1: 'Aquí puede cargar artículos a su carrito mediante archivos de Excel (.xlxs, .xls). En la columna "Códe", para identificar la variante, puede ingresar una lista de códigos EAN o una lista de códigos SKU.',
        MESSAGE1_1: 'La columna "Precio solicitado" es opcional y se puede utilizar para especificar un precio de venta deseado con el fin de calcular el descuento comercial en la línea de pedido.',
        MESSAGE2: 'En la columna "Code", mi archivo contendrá códigos:',
        MESSAGE3: 'Quieres subir el archivo:',
        OPERATION_ERRORS_DETAILS: 'Detalle del error de operación',
        DEFAULT_ERROR_MESSAGE: 'Se produjo un error durante el procesamiento del archivo.',
        COLUMNS: {
          ID: 'Id',
          CREATED_BY: 'Creado por',
          CREATED_ON: 'Creado el',
          STARTED_ON: 'Comenzó el',
          CONCLUDED_ON: 'Concluyó el',
          STATUS: 'Status',
          FILE_ROW_INDEX: 'Línea del archivo'
        }
      },
      FULFILLMENT: {
        FULFILLMENTS: 'Entregas',
        TITLE: 'Entrega #{{fulfillmentNumber}}',
        FULFILLMENT_STATUS: 'Estado entrega',
        FULFILLMENT_DATE: 'Fecha entrega',
        COURIER: 'Transportista',
        TRACKING_NUMBER: 'Número de seguimiento',
        TRACK_DELIVERY: 'Seguimiento de entrega',
        DOWNLOAD_DELIVERY_NOTE: 'Descargar albarán',
        SHIPPED: 'Enviado',
        DELIVERED: 'Entregado',
      },

      ORIGINAL_MODIFIED_INFORMATION: 'Información cambiada, original: {{originalValue}}',
      COMMERCIAL_BLOCK_INFO: 'Un bloque comercial está activo en el cliente actual.',
      NO_CART_CONF: 'Este carrito no se puede confirmar.',
      PAYMENT_TERM: 'Término de pago',
      ALREADY_FULFILLED_QUANTITY: 'Artículos de órdenes de planta',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_CUSTOMER_IS_NOT_APPROVED: 'No puedes confirmar este carrito porque el cliente no está aprobado',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_POINT_OF_SALE_IS_NOT_APPROVED: 'No puedes confirmar este carrito porque el punto de venta no está aprobado',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_HAS_NOT_ITEMS: 'No puedes confirmar este carrito porque no tiene artículos',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_LOWER_CART_VALUE: 'No puede confirmar este carrito porque el total del carrito es menor que el valor mínimo permitido en esta tienda',
      SOME_ORDER_ITEMS_IS_NOT_AVAILABLE_FOR_CURRENT_REQUESTED_QUANTITY: 'Algunos artículos del pedido no están disponibles para la cantidad solicitada',
      SUMMARY: 'Resumen',
      ORDER_ITEMS: 'Detalles artículos',
      ORDER_TYPE: 'Tipo de order',
      REORDER_TYPE: 'Tipo de re-order',
      ORDER_STATUS: 'Estado del pedido',
      CHANNEL_NAME: 'Nombre del canal',
      CHANNEL: 'Canal',
      CUSTOMER: 'Cliente',
      CUSTOMER_LOCATION: 'Dirección de facturación',
      POINT_OF_SALE: 'Punto de venta',
      AGENT: 'Agente',
      AGENCY: 'Agencia',
      USER: 'Usuario',
      USER_EMAIL: 'Email usuario',
      SHIPPING_ADDRESS: 'Direcciones de envío',
      CREATED_ON: 'Creado el',
      CONFIRMED_ON: 'Confirmado el',
      DELIVERY_DATE: 'Fecha de entrega',
      EXTERNAL_ID: 'ID externo',
      REASON: 'Causal',
      ORDER_REASON: 'Causal del pedido',
      MANUAL_DISCOUNT: 'Descuento manual',
      CUSTOMIZATION_REQUEST: 'Solicitud de personalización',
      NAME: 'Nombre',
      AMOUNT: 'Cantidad',
      NOTE: 'Nota',
      SELECT_ACTION_TYPE: 'Seleccione el tipo de acción',
      BACK_TO_ORDERS: 'Volver a pedidos',
      BACK_TO_CARTS: 'Volver a carritos',
      SAVED_NOTE: 'Nota guardada',
      ESTIMATED_DELIVERY_DATE: 'Fecha entrega estimada',
      DELETE_ORDER: 'Eliminar pedido',
      CANCEL_ORDER: 'Cancelar pedido',
      RESEND_ORDER_CONFIRMATION: 'Reenviar confirmación de pedido',
      ARE_YOU_SURE_YOU_WANT_TO_DELETE_SELECTED_ORDERS: '¿Está seguro de que desea eliminar los pedidos seleccionados?',
      ADD_ITEMS: 'Agregar artículos',
      EDIT_ITEMS: 'Editar artículos',
      EDIT_SELECTED: 'Editar seleccionados',
      DELETE_NOT_FULFILED_ITEMS: 'Eliminar articulos no evasos',
      ARE_YOU_SURE_YOU_WANT_TO_DELETE_SELECTED_ITEMS: '¿Está seguro de que desea eliminar los siguientes artículos?',
      CLOSE_SELECT_MODE: 'Cerrar modo selección',
      SUCCESS_RESEND_ORDER_CONFIRMATION: 'Reenvío de confirmación de pedido realizado con éxito',
      INVOICING_NUMBER_FULL_NAME: 'Número de cuenta de factura',
      CENTRAL_PAYMENT_NUMBER_FULL_NAME: 'Número de pago centralizado',
      MODAL: {
        ARE_YOU_SURE: '¿Está seguro?',
        CONFIRM: 'Confirmar',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: '¿Está seguro que desea eliminar este pedido?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CART: '¿Está seguro que desea eliminar este carrito?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_DISCOUNT: '¿Está seguro que desea eliminar descuento?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_VARIANT: '¿Está seguro que desea eliminar esta variante?',
        ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_SELECTED_VARIANTS: '¿Está seguro que desea eliminar estas variantes seleccionadas?',
        SET_MAXIMUM_QUANTITY_FOR_THIS_SELECTED_VARIANTS: '¡Atención! Al confirmar, se establecerá la cantidad máxima disponible relativa para cada variante seleccionada.',
      },
      DISCOUNT: {
        DISCOUNT_AMOUNT: 'Descuento adicional',
        DESCRIPTION_COMMERCIAL_DISCOUNT: 'Este descuento se aplicará a los artículos seleccionados',
        DESCRIPTION_FINANCIAL_DISCOUNT: 'Este descuento se aplicará a cada artículo en su carrito'
      },
      MODAL_EDIT_ORDERITEM: {
        EDIT_ORDER_ITEM: 'Editar artículo',
        ORDER_QTY: 'Cantidad pedida',
        MAXIMUM_QUANTITY_AVAILABLE_FOR_THIS_VARIANT_ON_DATE: 'Cantidad máxima disponible para esta variante en la fecha',
        IS: 'es:',
        YOU_ARE_BUYING_THIS_VARIANT_WHIT_BLANCK_CELL_OPTION: 'Está comprando esta variante con la opción de celda en blanco',
        MAX_AMOUNT_EXCEEDED: 'Cantidad máxima excedida',
        MINIMUM_ONE_PIECE: 'Mínimo 1 pieza',
        THE_QUANTITY_OF_THE_VARIANT_MUST_BE_A_MULTIPLE_OF: 'La cantidad de la variante debe ser un múltiplo de:',
        THE_QUANTITY_ENTERED_IS_LESS_THAN_THE_MINIMUM_ALLOWED: 'La cantidad ingresada es menor que el mínimo permitido',
        THE_MINIMUM_ORDER_QUANTITY_OF_THE_VARIANT_IS: 'La cantidad mínima de pedido de la variante es:',
        LOSE_CUSTOM_DELIVERY_DATES: '¡Al cambiar las cantidades de este artículo del pedido, perderá las fechas personalizadas que estableció! ¡Recuerda restablecerlo al confirmar tu pedido!',
      },
      MODAL_ORDER_NAME_CHANGE: {
        CHANGE_ORDER_NAME: 'Cambiar nombre del pedido',
      },
      MODAL_HANDLE_DATE: {
        HANDLE_DATE_BUTTON: 'Gestionar fechas',
        HANDLE_DATE: 'Administrar la fecha de solicitud de entrega original en las líneas de pedido',
        OVERWRITE_ORIGINAL_DATE: 'Utilice esta fecha para sobrescribir la fecha de solicitud de entrega original en los artículos del pedido seleccionados. De esta forma, en esta nueva fecha se realizarán controles de las cantidades disponibles para los artículos correspondientes. ¡Atención! ¡Al cambiar esta fecha, se perderán las fechas de entrega personalizadas!',
      },
      MODAL_SHIPPING_VARIANTS_DATE_: {
        LIST_VARIANTS_FROR_DELIVERY_DATE: 'Lista de variantes para la fecha de entrega',
      },
      BUTTONS: {
        EDIT: 'Modificar información del pedido',
        ADD_DISCOUNT_FINANCIAL: 'Añadir descuento financiero',
        ADD_DISCOUNT_COMMERCIAL: 'Añadir descuento comercial',
        REMOVE_DISCOUNT_FINANCIAL: 'Eliminar descuento financiero',
        REMOVE_DISCOUNT_COMMERCIAL: 'Eliminar descuento comercial',
        DISCOUNT_OPTIONS: 'Opciones descuento',
        CONFIRM_ORDER: 'Confirmar pedido',
        CONTINUE: 'Seguir comprando',
        DUPLICATE_CART: 'Duplicar carrito',
        SAVE_NOTE: 'Guardar nota',
        RENAME_ORDER: 'Renombrar pedido',
        REMOVE_CUSTOM_DATE: 'Eliminar fecha personalizada',
        SKIP_AUTOMATIC_DISCOUNT: 'Ignorar descuentos automáticos',
        SKIP_CUSTOMER_DISCOUNT: 'Ignorar descuento de cliente',
        ACTIVATE_AUTOMATIC_DISCOUNT: 'Activar descuentos automáticos',
        ACTIVATE_CUSTOMER_DISCOUNT: 'Activar descuento de cliente',
        ACTIVATE_STORECHANNEL_DISCOUNT: 'Activar descuentos store-channel',
        SKIP_STORECHANNEL_DISCOUNT: 'Ignorar descuentos store-channel',
        OPTIONS_ITEMS: 'Opciones de items',
        REMOVE_ITEMS: 'Eliminar items',
        SET_MAXIMUM_QUANTITY: 'Establecer cantidad máxima',
        COMMERCIAL_AGREEMENT: 'Acuerdo comercial',
        HANDLE_NOTE_BUTTON: 'Gestionar nota',
        EDIT_ORDER_HEADER: 'Modificar encabezado de pedido',
      },
      MODAL_CONFIRMATION_MAIL: {
        TITLE: 'Enviar correo electrónico de confirmación',
        SEND: 'Enviar',
        ACTIVATE_MAIL: 'Ingrese destinatarios personalizados',
        TO: 'A',
        CC: 'CC',
        CCN: 'CCN',
        TOOLTIP_MSG: 'Si no ingresa destinatarios personalizados, el correo electrónico de confirmación se enviará a las direcciones predeterminadas',
        ADD: 'Agregar',
        SNACKBAR_MESSAGE: 'El valor de entrada no es un correo electrónico válido'
      },
      MODAL_ACTIVATE_AUTOMATIC_DISCOUNT: {
        TITLE: 'Activar los descuentos automáticos',
        DESCRIPTION: '¿Está seguro? Si continúa, se activarán los descuentos automáticos para el carrito actual.'
      },
      MODAL_ACTIVATE_CUSTOMER_DISCOUNT: {
        TITLE: 'Activar descuento del cliente',
        DESCRIPTION: '¿Está seguro? Continuar activará cualquier descuento de cliente para el carrito actual.'
      },
      MODAL_SKIP_AUTOMATIC_DISCOUNT: {
        TITLE: 'Ignorar los descuentos automáticos',
        DESCRIPTION: '¿Está seguro? Si continúa, se ignorarán los descuentos automáticos para este carrito específico.'
      },
      MODAL_SKIP_CUSTOMER_DISCOUNT: {
        TITLE: 'Ignorar el descuento del cliente',
        DESCRIPTION: '¿Está seguro? Si continúa, se ignorará cualquier descuento de cliente para el carrito actual.'
      },
      MODAL_ACTIVATE_STORECHANNEL_DISCOUNT: {
        TITLE: 'Activar los descuentos store-channel',
        DESCRIPTION: '¿Está seguro? Si continúa, se activarán los descuentos store-channel para el carrito actual.'
      },
      MODAL_SKIP_STORECHANNEL_DISCOUNT: {
        TITLE: 'Ignorar los descuentos store-channel',
        DESCRIPTION: '¿Está seguro? Si continúa, se ignorarán los descuentos store-channel para este carrito específico.'
      },
      SHOW_ONLY_UNAVAILABLE: 'Mostrar solo artículos con cantidad disponible menor a la solicitada',
      ADD_MANUAL_DISCOUNT_MANUAL: 'Ingrese % de descuento adicional',
      ADD_MANUAL_DISCOUNT_CALCULATED: 'Calcular a partir del % de descuento deseado del retail',
      ADD_MANUAL_DISCOUNT_CALCULATED2: 'Calcular a partir del wholesale unitario deseado',
      ADD_MANUAL_DISCOUNT_CALCULATED3: 'Calcular a partir del % del margen deseado',
      INSERT_PERCENTAGE: 'Ingrese el porcentaje',
      INSERT_DESIRED_WHOLESALE: 'Ingrese wholesale deseado',
      HIDE_CANCELLED: 'Hide cancelled order items',
      COMMERCIAL_DISCOUNT_APPLIED: 'Descuento comercial aplicado en {{orderItemsCount}} {{itemsTranslation}} de pedido.',
      ITEM: 'artículo',
      ITEMS: 'artículos',
      SOME_ORDERITEMS_HAS_NO_COST: 'Algunos artículos del carrito no tienen un costo especificado, por lo tanto, esta función no está disponible',
      PENDING_OPERATION: 'No puede realizar operaciones en el carrito ya que se están procesando cargas de líneas de pedido a través de un archivo Excel.',
      CHOOSE_EXCEL_PROPS_TITLE: 'Elige propiedades',
      CHOOSE_EXCEL_PROPS: 'Elija las columnas que se mostrarán en la hoja de Excel dedicada a los artículos de pedido',
      CUSTOM_DATE: 'Fecha personalizada',
      EDIT_CUSTOM_DATE: 'Personalizar fecha',
      NO_CUSTOM_DATE: 'Fecha no personalizable',
      SELECTED_ITEMS: 'líneas de pedido seleccionadas',
      ALERT_CART_SHIPPING_COST: 'A este carrito se le aplicarán los costos de envío de <strong>{{shippingCost}}</strong> (VAT excluido); para obtenerlos gratis, aún debes agregar <strong>{{threshold}}</strong>.',
      ALERT_CART_SHIPPING_COST_NO_COST: 'A este carrito se le aplicarán los costos de envío. Para obtenerlos gratis, aún debes agregar <strong>{{threshold}}</strong>.',
      ALERT_CART_SHIPPING_COST_WITH_VOUCHER: 'Si utilizas un bono, no se te cobrará.',
      COLUMNS: {
        IMAGE: 'Imagen',
        NAME: 'Columnas',
        SKU: 'Sku',
        COLOR: 'Color',
        COLOR_CODE: 'Código color',
        COLOR_NAME: 'Nombre color',
        SIZE: 'Talla',
        UNIT_WHOLESALE: 'Wholesale unit.',
        UNIT_RETAIL: 'Retail unit.',
        GENDER: 'Género',
        UNIT_NET: 'Neto unit.',
        UNIT_COST: 'Coste unit.',
        UNIT_MARGIN: 'Margen unit.',
        TOTAL_RETAIL: 'Retail tot.',
        TOTAL_WHOLESALE: 'Wholesale tot.',
        TOTAL_NET: 'Neto tot.',
        TOTAL_COST: 'Coste tot.',
        TOTAL_MARGIN: 'Margen tot.',
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Desc. desde retail',
        TOTAL_DISCOUNT_PERCENTAGE: 'Desc. desde wholesale',
        CUSTOMER_DISCOUNT: 'Desc. cliente',
        AGREEMENT_DISCOUNT: 'Desc. acuerdo com.',
        FINANCIAL_DISCOUNT: 'Desc. financiero',
        STORECHANNEL_DISCOUNT: 'Desc. store-channel',
        DISCOUNT_BY_QTY: 'Desc. by qty',
        DISCOUNT_BY_VALUE: 'Desc. by value',
        COMMERCIAL_DISCOUNT: 'Desc. comercial',
        MARGIN_PERCENTAGE: 'Margin',
        QTY: 'Qty',
        EAN: 'EAN',
        SIZE_GROUP: 'Grupo tamaño',
        PRODUCT_CODE: 'Código producto',
        PRODUCT_TITLE: 'Nombre producto',
        DATE: 'Data',
        ORDERED_QTY: 'Qty pedida',
        CANCELED_QTY: 'Qty cancelada',
        NOT_FULFILLED_QTY: 'Qty no cumplida',
        FULFILLED_QTY: 'Qty cumplida',
        FULFILLMENT_STATUS: 'Estado de cumplimiento',
        GROUP_GENERAL: 'Generales',
        GROUP_UNITARY: 'Unitario (€)',
        GROUP_TOTALS: 'Totales (€)',
        GROUP_PERCENT: 'Porcentajes (%)',
        GROUP_FULFILLMENT: 'Cumplimiento',
        STYLE_GROUP: 'Style group',
        NOTE: 'Notas',
        CUSTOMIZATION_REQUEST: 'Solicitud de personalización',
      },
    },
    REGISTRATION: {
      WELCOME: 'Bienvenido a',
      REGISTER_NEW: 'Registrar una nueva',
      BACK_TO_HOME: 'Volver',
      LOGOUT: 'Logout',
      CUSTOMER: 'Cliente',
      CUSTOMER_INFO: 'Información al cliente',
      AGENCY: 'Agencia',
      AGENCY_INFO: 'Información de la agencia',
      INFO_SETUP: 'Agregar información general',
      STEPPER: {
        REQUIRED_INFOTO_CREATE: 'Para crear un nuevo cliente sin enviarlo al ERP, la información necesaria es: ',
        REQUIRED_INFOTO_CREATE2: 'Número de cuenta (Pestaña: Info cliente), Nombre de la empresa (Pestaña: Info cliente), Conocido como (Pestaña: Info cliente), Dirección de facturación (Pestaña: Info cliente), Correo electrónico administrativo (Pestaña: Info cliente), al menos un punto de venta (Pestaña: Direcciones de envío).',
        REQUIRED_INFOTO_CREATE3: '¡Recuerda! Puedes crear el punto de venta directamente a partir de los datos de facturación y no se duplicará en el ERP. En el paso Direcciones de envío luego podrás guardar los datos.',
        ADD_NEW: 'Añadir nuevo',

        CONTACT_INFO: 'Datos de contacto',
        ADD_CONTACT_INFO: 'Agregar datos de contacto',

        PAYMENT_INFO: 'Información de pago',
        ADD_PAYMENT_INFO: 'Agregar información de pago',

        POINT_OF_SALE: 'Puntos de venta',
        NEW_POINT_OF_SALE: 'Nuevo punto de venta',
        ADD_POINT_OF_SALE: 'Agregar un punto de venta',
        ENABLED_ONLINE_STORE: 'Tienda online habilitada',
        USE_BILLING: 'Utilice la dirección de facturación',
        FINANCIAL_STATUS: 'Estado financiero',
        COMPANY_FINANCIAL_STATUS: 'Estado financiero de la empresa',

        FINISH_REGISTRATION: 'Finalizar registro',
        FINISH_REGISTRATION_TEXT: 'Una vez enviada la solicitud de inscripción, será atendida.',
        SEND_REGISTRATION_REQUEST: 'Enviar solicitud de registro',

        NEXT_STEP: 'Próximo paso',
        PREV_STEP: 'Paso anterior',
        SEND_REQUEST: 'Enviar petición',
        OWNER: 'Propietario',
        OWNER_SUB: 'Propietario de la empresa',
        SEND_USER_INVITATION: 'Enviar correo electrónico de invitación al propietario',
        POS_WITHOUT_STORE: 'Debe habilitar cada tienda para al menos una tienda en línea y el canal correspondiente',
        FORWARDED_REQUEST: 'Su solicitud ha sido enviada al servicio de atención al cliente',
        USER: {
          EXISTING: 'Elija un usuario existente',
          NEW: 'Crear un nuevo usuario',
          SELECT_USER: 'Seleccionar usuario',
          EXISTING_EMAIL: 'El Email ya existe'
        }
      }
    },
    PRODUCT_DETAIL: {
      IMAGES_VISIBILITY_ACTION: 'Ocultar imágenes de este producto',
      IMAGES_VISIBILITY_INFO: 'Al activar esta opción, las imágenes de las variantes del producto no se mostrarán al cliente en ninguna sección de la aplicación (como la lista de productos, la página de detalles o las pantallas de confirmación del pedido). Esta configuración tiene prioridad sobre la visibilidad configurada para las imágenes individuales de las variantes, que puedes gestionar en el detalle de cada variante.',
      IMAGES_VISIBILITY: 'Visibilidad de imágenes',
      BACK_TO_PRODUCTS_LIST: 'Volver a lista de productos',
      STYLE_CARD: 'Tarjeta de estilo',
      NAME: 'Nombre',
      CODE: 'Código',
      GENDER: 'Género',
      DESCRIPTION: 'Descripción',
      PRODUCT_DESCRIPTION: 'Descripción del producto',
      OPEN_IN_BULK: 'Abrir en el editor de variantes',
      COLOR: 'color',
      COLORS: 'colores',
      SETTINGS_PRODUCT: 'Configuración de compra',
      SETTING_BASICKUSTOM: 'Configuración BasicKustom',
      MESSAGE_FOR_MAKE_PRODUCT_CUSTOMIZABLE: 'Para personalizar este producto, seleccione una palette de referencia',
      MESSAGE_FOR_MAKE_PRODUCT_CUSTOMIZABLE_WITH_PLAYERS: 'Activa esta opción si deseas permitir al usuario agregar información relacionada con los jugadores a este producto',
      BUY_MULTIPLIER: 'Multiplicador de compras para los canales: {{channels}}',
      BUY_MINIMUM_PER_ORDER: 'Cantidad mínima de compra (para canales de venta que lo requieran)',
      ADD_ORDER_ITEMS: 'Añadir artículos al pedido',
      ORDER_ITEM_WITHOUT_WHOLESALE_PRICE: '¡Atención! Algunas variantes seleccionadas no tienen un precio mayorista definido y no se podrán añadir.',
      VARIANTS: {
        NAME: 'Variante',
        COLUMNS: {
          VARIANT: 'Variante',
          QTY: 'Cantidad',
          NEW_QTY: 'Nueva cantidad',
          SKU: 'Sku',
          WHOLE_SALE: 'Wholesale',
          RE_ORDER: 'Re-order',
          PRE_ORDER: 'Pre-order',
        }
      },
      IMPORT_STATUS: {
        NAME: 'Estado de importación',
        START: 'Comienzo',
        END: 'Fin',
        ERROR: 'Ocurrió el siguiente error: ',
        RESTART_IMPORT: 'Reiniciar importación',
        MODAL_TEXT: 'Atención! Se perderán todos los cambios relacionados con este producto y sus variantes. Está seguro?',
        RETAIL_DISCOUNT_PERCENTAGE: '% de descuento del retail',
        LAST_RETAIL_DISCOUNT_PERCENTAGE: 'Último descuento base utilizado'
      },
      MODAL_DELETE: {
        ARE_YOU_SURE: '¿Estás seguro?',
        ARE_YOU_SURE_TO_REMOVE_STOCK_LIMIT: '¿Estás seguro de que quieres eliminar el límite de stock?',
        ARE_YOU_SURE_TO_REMOVE_MINIMUM_PRE_ORDER: '¿Estás seguro de que quieres eliminar el pre-order mínimo?',
        ARE_YOU_SURE_TO_REMOVE_MINIMUM_RE_ORDER: '¿Estás seguro de que quieres eliminar el re-order mínimo?',
        ARE_YOU_SURE_TO_REMOVE_ALL_LIMITS: '¿Estás seguro de que quieres eliminar todos los límites?',
        FOR: 'para',
        STYLE_COLOR: 'producto-color',
        STYLE_COLORS: 'productos-color',
      },

      SETTING_LIMIT: 'Establecer restricciones',
      SETTING_STOCK_LIMIT: 'Configuración de límite de stock',
      SETTING_MINIMUM_PRE_ORDER: 'Configuración de pre-order mínimo',
      SETTING_MINIMUM_RE_ORDER: 'Configuración de re-order mínimo',
      ADD_OR_EDIT_STOCK_LIMIT: 'Agregar/editar límite de stock',
      ADD_OR_EDIT_MINIMUM_PRE_ORDER: 'Agregar/editar pre-order mínimo',
      ADD_OR_EDIT_MINIMUM_RE_ORDER: 'Agregar/editar re-order mínimo',
      REMOVE_STOCK_LIMIT: 'Eliminar límite de stock',
      REMOVE_MINIMUM_PRE_ORDER: 'Eliminar pre-order mínimo',
      REMOVE_MINIMUM_RE_ORDER: 'Eliminar re-order mínimo',
      REMOVE_ALL_LIMITS: 'Eliminar todos los límites',
      MODAL_LIMIT: {
        STOCK_LIMIT: 'Límite de stock',
        MINIMUM_QTY_PRE_ORDER: 'Pre-order mínimo',
        MINIMUM_QTY_RE_ORDER: 'Re-order mínimo',
        SETTING_STOCK_LIMIT: 'Configuración de límite de stock',
        SETTING_MINIMUM_PRE_ORDER: 'Configuración de pre-order mínimo',
        SETTING_MINIMUM_RE_ORDER: 'Configuración de re-order mínimo',
        LIMIT_ENABLED_FOR_CHANNELS: 'Límite habilitado para canales: {{channels}}',
        THE_QUANTITY_INSERTED_IS_NOT_VALID_MINIMUM_VALUE_IS_TWO: 'La cantidad insertada no es válida. El valor mínimo es 2',
      },
    },
    PRODUCT_AND_VARIANT: {
      REORDER: 'Organizar',
    },
    TAG_MANAGER: {
      NAME: 'Gestor de etiquetas',
    },
    MEDIA_CONTAINER: {
      START_SYNC: 'Iniciar alineación imágenes',
      NAME: 'Media',
      VISIBLE_IMAGE: 'Imagen visible',
      SET_AS_COVER: 'Establecer como portada',
      NO_MEDIA_TO_VIEW: 'No hay media para ver',
      UPLOAD_MEDIA: 'Subir media',
      SHOW_ALL_MEDIA: 'Mostrar todos los media',
      HIDE_ALL_MEDIA: 'Ocultar todos los media',
    },
    BULK_MEDIA_EDIT: {
      SHOW: 'Mostrar',
      HIDE: 'Ocultar',
      INFO: 'Mostrar u ocultar todos los medios (Producto y Variantes)',
      NO_PRODUCT_SELECTED: 'No hay productos seleccionados',
      MESSAGE_SUCCESS_VISIBILE_1: 'Todas las imágenes de los productos seleccionados se han hecho visibles',
      MESSAGE_SUCCESS_VISIBILE_2: 'Todas las imágenes del producto y variantes se han hecho visibles.',
      MESSAGE_SUCCESS_HIDE_1: 'Todas las imágenes de los productos seleccionados se han hecho invisibles',
      MESSAGE_SUCCESS_HIDE_2: 'Todas las imágenes de productos y variantes se han hecho invisibles.',
    },
    VARIANT_DETAIL: {
      BACK_TO_PRODUCT_DETAIL: 'Volver a detalle del producto',
      VARIANT: 'Variante',
      SELECT_VARIANT: 'Seleccionar variante',
      COLOR: 'Color',
      SIZE: 'Talla',
      SKU_CODE: 'Código SKU',
      EAN_CODE: 'Código EAN',
      AVAILABLE_QTY: 'Cantidad de stock',
      COST: 'Costo',
      BLANK_CELLS_SETTINGS: 'Ajustes de blank cells',
      BLANK_CELLS_END_DATE: 'Fecha de fin de blank cells',
      BLANK_CELLS_DELIVERY_DATE: 'Fecha de entrega de blank cells',
      TIERING: 'Tiering',
      TIER_DESCRIPTION: 'Seleccione los tier para los que está disponible el producto:',
      EXTERNAL_COLLECTIONS_ID: 'ID de colección externa',
      FROM: 'Desde',
      TO: 'Hasta',
      DETAIL: 'Detalle',
      LABELS: 'Etiquetas',
      PURPOSES: 'Propósitos',
      TEAMS: 'Equipos',
      CATEGORIES: 'Categorías',
      PRICING: 'Precio',
      PRE_ORDER: 'Pre-orden',
      RE_ORDER: 'Re-orden',
      WHOLE_SALE_PRICE_NO_VAT: 'Precio wholesale (sin VAT)',
      SUGGESTED_RETAIL_PRICE_VAT: 'Precio retail sugerido (con VAT)',
      PERCENTAGE_DISCOUNT_OF_RETAIL: '% de descuento del retail',
    },
    VISIBILITY: {
      NAME: 'Visibilidad',
      PUBLISH_ON_PRE_ORDER: 'Publicar en pre-order',
      PUBLISH_ON_RE_ORDER: 'Publicar en re-order',
      BLOCK_AUTOMATIC_PUBLISH_ON_RE_ORDER: 'Bloquear publicación automática en re-order',
      AUTOMATIC_PUBLISH_DESCRIBE: 'Si está desactivada, cuando la variante tenga cantidad de re-order disponible, se publicará automáticamente'
    },
    ASSORTMENT_DETAIL: {
      NAME: 'Asortamiento',
      BACK_TO_ASSORTMENTS: 'Volver a asortamientos',
      ASSORTMENT_CARD: 'Tarjeta de asortamiento',
      ASSORTMENT_NAME: 'Nombre',
      ID: 'ID',
      EDIT_ORDER: 'Editar orden',
      DESCRIPTION: 'Descripción (opcional)',
      TIERING: 'Tiering',
      TIER_DESCRIPTION: 'Seleccione los tier para los que está disponible el asortamiento:',
      CHANNEL: 'Canal',
      SELECT_THE_CHANNEL_FIRST: 'Seleccione el canal primero',
      CHANNEL_DESCRIPTION: 'Seleccione los canales para los que está disponible el asortamiento:',
      INCLUDE_PRODUCTS: {
        NAME: 'Incluir productos',
        MANUAL: 'Manual (estático)',
        AUTOMATED: 'Automático (dinámico)',
        PROPERTY: {
          CODE: 'Código',
          SIZE: 'Talla',
          COLOR: 'Color',
          TIER: 'Tier',
          PRICE: 'Precio',
          BRAND: 'Marca',
          GENDER: 'Género',
          SEASON: 'Temporada',
          TAG: 'Tag',
          CATEGORY: 'Categoría',
          LABEL: 'Label',
          EXTERNAL_COLLECTION_ID: 'ID de colección externa',
          PRODUCT_CODE: 'Código de producto',
        },
        OPERATOR: {
          EQUALS: 'Igual a',
          NOT_EQUALS: 'No igual a',
          GREATER_THAN: 'Mayor que',
          LESS_THAN: 'Menor que',
          GREATER_OR_EQUAL: 'Mayor o igual que',
          LESS_OR_EQUAL: 'Menor o igual que',
          CONTAINS: 'Contiene',
          NOT_CONTAINS: 'No contiene',
          STARTS_WITH: 'Empieza con',
          ENDS_WITH: 'Termina con',
        },
        GENDER: {
          MAN: 'Hombre',
          WOMAN: 'Mujer',
          UNISEX: 'Unisex'
        }
      },
      ASSORTMENT_PRODUCTS: 'Productos del asortamiento',
      ASSORTMENT_INFO_1: 'El orden de esta lista afecta cómo se muestran los productos en la lista de productos de 4Shop.',
      ASSORTMENT_INFO_2: 'Para editar el pedido de productos, primero debe guardar los cambios sobre las variantes de surtido, incluidas las reglas automáticas de surtido.',
      UNDO_PRODUCTS_ORDER: 'Deshacer el orden de los productos',
      SAVE_PRODUCTS_ORDER: 'Guardar el orden de los productos',
      FEATURED: 'Resaltado',
    },
    AUTOMATED_INCLUDES: {
      ALL_CONDITION: 'Todas las condiciones',
      ANY_CONDITION: 'Cualquier condición',
      PROPERTY: 'Propiedad',
      OPERATOR: 'Operador',
      VALUE: 'Valor',
    },
    BULK_EDITOR_DETAIL: {
      CHOOSE_PROPS: 'Elija las propiedades para editar',
      BACK_TO_SELECT_VARIANTS: 'Volver a seleccionar variantes',
      EDIT_INFO: 'Puede editar múltiples variantes al mismo tiempo seleccionándolas. Mantenga presionado el botón Shift para seleccionar grupos de variantes más rápido.',
      COLUMNS: {
        COLOR: 'Color',
        SIZE: 'Talla',
        SKU: 'SKU',
        RE_ORDER: 'Re-order',
        PRE_ORDER: 'Pre-order',
        AUTO_RE_ORDER: 'Bloquear re-order automático',
        BLANK_CELLS_END: 'Fecha de fin de celdas en blanco',
        BLANK_CELLS_DELIVERY: 'Fecha de entrega de celdas en blanco',
        TAGS: 'Etiquetas',
        TIERS: 'Tiers',
        PRICES: 'Precios',
      },
    },
    SUPER_BULK_EDITOR_DETAIL: {
      CREATE_OPERATION: 'Crear operación',
      MANUAL_CODE: 'Manual',
      AUTO_CODE_BY_ASSORTMENT: 'Por asortamiento',
      LIST_OPERATION: 'Lista de operaciones',
      SELECT_THE_TYPE_OF_CODE: 'Seleccione el tipo de código',
      SELECT_TYPE_OF_CODE_DESC: 'En este apartado selecciona el tipo de códigos que introducirás para obtener el listado de variantes sobre las que realizar las operaciones.',
      BEFORE_SELECT_THE_TYPE_OF_CODE: 'Primero seleccione el tipo de código',
      INSERT_CODES: 'Inserte los códigos a generar',
      INSERT_CODES_DESC: 'En esta sección ingrese una lista de códigos según el tipo seleccionado previamente, separándolos con un ";" o por retorno de carro para cada código.',
      REPORT_VALIDATION: 'Informe de validación',
      BEFORE_INSERT_CODES_AND_VALIDATED: 'Primero ingrese los códigos y valide',
      TOTAL_VARIANTS_INVOLVED: 'Total de variantes involucradas',
      CREATE_OPERATION_DESC: 'En esta sección elija la operación que se realizará en la lista de variantes involucradas.',
      SELECT_OPERATION: 'Seleccione la operación a realizar',

      CODE_TYPE: {
        BASIC_COLLECTION: 'Colección',
        PRODUCT_CODE: 'Producto',
        PRODUCT_TEAM: 'Producto team',
        PRODUCT_COLOR: 'Producto color',
        SKU_CODE: 'SKU',
      },

      CODE_TYPE_TOOLTIP: {
        BASIC_COLLECTION: 'Id colección basic, Ej. 12345',
        PRODUCT_CODE: 'Código de producto, primeros 7 caracteres del código SKU, Ej. 35124DW',
        PRODUCT_TEAM: 'Código de producto del equipo, primeros 10 caracteres del código SKU, Ej. 35124DWACF or 35124DW***',
        PRODUCT_COLOR: 'Código de producto de color, primeros 13 caracteres del código SKU, Ej. 35124DW***A00 o 35124DW A00',
        SKU_CODE: 'Código 19, Ej. 35124DW***A00L***** o 35124DW A00L',
      },

      REPORT_VALIDATION_MODAL: {
        TITLE: 'Informe de validación',
        VALIDATING: 'Validando...',
        ALERT_MESSAGE: 'Algunos códigos ingresados no son correctos ({{numberOfCodesInvalid}}), para continuar, elimínelos o corríjalos'
      },

      COLUMNS: {
        CODE: 'Código',
        VARIANTS_NUMBER: 'Número de variantes',
        STATUS: 'Estado',
        INSERTED: 'Insertado',
        INTERPRETED: 'Interpretado',
      },
      BUTTONS: {
        EDIT_CODES: 'Editar códigos',
        UNDO_EDITS: 'Deshacer ediciones',
        ADD_ROW: 'Añadir fila',
        VALIDATE: 'Validar',
      },

      ALERT: {
        NO_VARIANTS_FOUND_PLEASE_CHECK_THE_CODES: 'No se encontraron variantes, verifique los códigos',
        OPERATION_CREATED_SUCCESSFULLY: 'La operación #{{operationId}} se creó correctamente',
      },

      OPERATION_LABELS: {
        VISIBLE_IN_RE_ORDER: 'Visible en re-order',
        VISIBLE_IN_PRE_ORDER: 'Visible en pre-order',
        BLOCK_AUTOMATIC_PUBLISH_ON_RE_ORDER: 'Bloquear publicación automática en re-order',
        BLANK_CELLS_END_DATE: 'Fecha de fin de celdas en blanco',
        BLANK_CELLS_DELIVERY_DATE: 'Fecha de entrega de celdas en blanco',
        INCLUDE_IN_TIER: 'Incluir en tier',
        EXCLUDE_FROM_TIER: 'Excluir de tier',
        INCLUDE_IN_ASSORTMENT: 'Incluir en surtido',
        EXCLUDE_FROM_ASSORTMENT: 'Excluir de surtido',
        INCLUDE_IN_PROMOTION: 'Incluir en promoción',
        EXCLUDE_FROM_PROMOTION: 'Excluir de promoción',
        PALETTES_STOCK_LIMITS: 'Límite de stock establecido: ',
      },

      DETAIL_OPERATION_MODAL: {
        TITLE: 'Detalle de la tarea #{{operationId}}',
        MESSAGE: 'La <strong>operación #{{ OperationId}}</strong> creada por <strong>{{userName}}</strong> el <strong>{{date}}</strong> está en estado: <strong>{{status}}</strong>',
        OPERATION_REQUESTED: 'Operación solicitada: ',
        ERROR_FOUND: 'Error encontrado: ',
        ERRORS_FOUND: 'Errores encontrados: ',

        COLUMNS: {
          VARIANT_SKU: 'SKU variante',
          ERRORS: 'Errores',
        },
      },
    },
    SUPPORT_BUTTON: {
      LABEL: 'AYUDAR',
      TITLE: 'Complete los campos para enviar una solicitud de soporte',
      SUCCESS_MESSAGE: 'Solicitud enviada con éxito!',
      OBJECT: 'Objeto',
      MESSAGE_BODY: 'Mensaje',
      BROWSE_FILE: 'Navegar...',
      FEEDBACK_MESSAGE_0: 'Ticket creado con identificación #',
      FEEDBACK_MESSAGE: 'Responderemos a su solicitud con un correo electrónico a',
      SEND_REQUEST: 'Enviar petición',
      CHOOSE_FILE: 'Añadir archivo',
    },
    PROMOTION_DETAIL: {
      NAME: 'Descuentos automáticos',
      EVALUATE_REQUIREMENTS_CONSIDERING_ENTIRE_ORDER: 'Evaluar requerimientos considerando todo el pedido',
      NEW_PROMOTION: 'Nueva descuento automático',
      BACK_TO_PROMOTIONS: 'Volver descuentos automáticos',
      PROMOTION_NAME: 'Nombre',
      CODE: 'Código',
      VALIDITY: 'Validez',
      VALID_FROM: 'Válido desde',
      VALID_UNTIL: 'Válido hasta',
      VALID_ON: 'Válido en',
      REQUIREMENTS_AND_DISCOUNT: 'Requisitos y descuento',
      MINIMUM_QUANTITY: 'Cantidad mínima',
      MINIMUM_VALUE: 'Valor mínimo',
      FROM: 'Desde',
      TO: 'Hasta',
      DISCOUNT: 'Descuento',
      INCLUDE_VARIANTS: 'Incluir variantes',
      INCLUDED_VARIANTS: 'Variantes incluidas',
      MESSAGE: 'No se puede seleccionar alguna variante porque ya está presente en otra promoción del mismo tipo',
      VARIANTS: 'Variantes',
      ERROR_APPLICATION_RANGE: {
        RANGE_IS_INCORRECT_FROM_MUST_BE_LESS_THAN_TO: 'El rango es incorrecto. "Desde" debe ser menor que "Hasta"',
        THE_INTERVAL_OVERLAPS_WITH_ANOTHER_INTERVAL: 'El intervalo se superpone con otro intervalo',
        THE_VALUE_FRO_THE_DISCOUNT_MUST_BE_BETWEEN_1_AND_100: 'El valor del descuento debe estar entre 1 y 100',
        THE_VALUE_FOR_TO_MUST_BE_GREATER_THAN_0_OR_EMPTY: 'El valor de "Hasta" debe ser mayor que 0 o vacío',
      },
      INFO_APPLICATION_RANGE: {
        THIS_INPUT_WHITEOUT_VALUE_WILL_BE_CONSIDERED_AS_INFINITY: 'Este campo sin valor se considerará como infinito',
      },
    },
    VOUCHER_DETAIL: {
      NAME: 'Voucher',
      NEW_VOUCHER: 'Nuevo voucher',
      NEW_VOUCHER_FOR: 'Nuevo voucher para',
      BACK_TO_VOUCHERS: 'Volver vouchers',
      VOUCHER_NAME: 'Nombre',
      VALIDITY: 'Validez',
      CUSTOMER_TO_APPLY: 'Clientes a los que asignar cupón',
      CUSTOMER_APPLIED: 'Clientes a los que se les ha concedido el bono',
      ADD_CUSTOMER: 'Sgregar cliente',
      CUSTOMER: 'Cliente',
      SELECTED: 'Seleccionado',
      DESELECT_ALL: 'Deseleccionar todo',
      NO_CUSTOMER_SELECTED: 'Ningún cliente seleccionado',
      EXPIRED_VOUCHER: 'El cupón seleccionado está caducado!',
      EDIT_DESCRIPTION: 'Editar descripción',
      RESIDUAL_AMOUNT: 'Cantidad residual',
      SELECT_AT_LEAST_ONE_CUSTOMER: 'Seleccione al menos un cliente',
      FILL_IN_ALL_REQUIRED_FIELDS: 'Rellene todos los campos obligatorios',
      CHANGE_VOUCHER: 'Cambiar voucher',
      APPLICABLE_AS_PARTIAL_PAYMENT: 'Aplicable como pago parcial',
      APPLICABLE_AS_PARTIAL_PAYMENT_MESSAGE: 'Si está habilitado, el cupón será aplicable a un pedido incluso si su monto restante no puede cubrir el total mayorista descontado del pedido.',
    },
    ASSIGN_VOUCHER: {
      SELECT_VOUCHER: 'Selecciona el bono que quieres aplicar al pedido',
      SELECTION_MESSAGE: 'Aplicando este bono, el total del pedido será ',
    },
    AGENCY_DETAIL: {
      TABS: {
        SUMMARY: 'Resumen',
        CHECK_IN: 'Check-in',
        CUSTOMERS: 'Clientes',
        ORDERS: 'Pedidos',
        AGENTS: 'Agentes',
      },
      PLEASE_INSERT_AGENCY_CODE_FOR_ALL_ACTIVE_STORES: 'Por favor, introduzca el código de agencia para todas las tiendas activas',
      AGENCY_CODES: 'Códigos de agencia',
      BACK_TO_AGENCIES: 'Volver a agencias',
      AGENCY_INFORMATION: 'Información de agencia',
      VAT: 'IVA',
      FISCAL_CODE: 'Código fiscal',
      AGENCY_CODE: 'Código de agencia',
      AGENCY_NAME: 'Nombre de agencia',
      AGENCY_FORM: 'Formulario de agencia',
      CANT_EDIT: {
        MESSAGE: '¡No puede editar la información sobre la agencia porque está pendiente de aprobación!',
      },
      SEND_TO_ERP: 'Enviar a ERP',
      CONTACT_INFO: 'Información de contacto',
      MODAL_ERP: {
        ARE_YOU_SURE: '¿Está seguro?',
        ARE_YOU_SURE_YOU_WANT_TOSEND_TO_ERP: '¿Está seguro de que desea enviar a ERP?',
        SEND: 'Enviar',
      }
    },
    ADDRESS_INFO: {
      SEARCH: 'Buscar',
      ADDRESS: 'Dirección',
      ALTERNATIVE_ADDRESS: 'Dirección alternativa',
      LABEL: 'Buscar dirección',
      BILLING_LABEL: 'Buscar dirección de envio',
      STREET: 'Calle',
      NUMBER: 'Número',
      COUNTRY: 'País',
      PROVINCE: 'Provincia',
      CITY: 'Ciudad',
      ZIP_CODE: 'Código postal',
    },
    CONTACT_INFO: {
      DELETE_MODAL: {
        ARE_YOU_SURE: '¿Está seguro?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: '¿Está seguro de que desea eliminar este contacto?',
        DELETE: 'Eliminar',
      },

      ADD_MODAL: {
        TITLE: 'Añadir contacto',
        TYPE: 'Tipo',
      },

      EDIT_MODAL: {
        TITLE: 'Editar contacto',
      },

      CONTACT_TYPE: {
        ADMINISTRATIVE: 'Administrativo',
        COMMERCIAL: 'Comercial',
        EMAIL: 'Email',
        PEC: 'PEC',
        PHONE: 'Teléfono',
        FAX: 'Fax',
        MOBILE: 'Móvil',
        WEBSITE: 'Sitio web',
        SOCIAL: 'Social',
        FACEBOOK: 'Facebook',
        TWITTER: 'Twitter',
        INSTAGRAM: 'Instagram',
        LINKEDIN: 'Linkedin',
      }
    },
    CUSTOMER_DETAIL: {
      BACK_TO_CUSTOMERS: 'Volver a clientes',
      TABS: {
        SUMMARY: 'Resumen',
        CHECK_IN: 'Check-in',
        LOCATIONS: 'Localizaciones',
        ORDERS: 'Pedidos',
        DISCOUNTS: 'Descuentos',
        USERS: 'Usuarios',
        VOUCHERS: 'Vouchers',
        SETTINGS: 'Envíos',
      },

      ALLERT: {
        MESSAGE: '¡No puede editar la información del cliente porque está pendiente de aprobación!',
      },

      SEND_TO_ERP: 'Enviar a ERP',

      CARDS: {
        COMPANY_INFO: 'Información de la empresa',
        CONTACT_INFO: 'Información de contacto',
        COMPANY_FINANCIAL_STATUS: 'Estado financiero de la empresa',
        PAYMENT_INFO: 'Información de pago',
        COMMERCIAL_AGREEMENT: 'Acuerdo comercial',
        CUSTOMER_DISCOUNT: 'Descuento del cliente',
        CUSTOMER_COMMERCIAL_BLOCK: 'Bloque comercial del cliente',
        BASIC_KUSTOM_DISCOUNT: 'Descuento kustom básico',
      },

      STATUS: {
        COMPLETED: 'Completado',
        NOT_COMPLETED: 'No completado',
      },

      MODAL_ERP: {
        ARE_YOU_SURE_YOU_WANT_TO_SEND_TO_ERP: '¿Está seguro de que desea enviar a ERP?',
        MESSAGE: 'Al confirmar, el registro se guardará y se transmitirá a ERP',
        SEND: 'Enviar',
      },

      MODAL_SAVE: {
        ARE_YOU_SURE: '¿Está seguro?',
        MESSAGE: '¡Atención! guardando el cambio para el cliente, se establecerá con el estado "por aprobar"',
      },

      COMPANY_INFO: {
        PREFIX_VAT: 'prefijo IVA',
        VAT_WHITHOUT_PREFIX: 'IVA sin prefijo',
        FISCAL_CODE: 'Código fiscal',
        COMPANY_NAME: 'Nombre de la empresa',
        AUTOCOMPLETE: 'Autocompletar',
        COMPANY_FORM: 'Formulario de empresa',
        COMPANY_CATEGORIES: 'Categorías de empresa',
        ITALIAN_DIGITAL_INVOICING_SYSTEM: 'Sistema de facturación electrónica italiano',
        SDI_CODE: 'Código SDI',
        OFFICE_PA_CODE: 'Código PA',
        PEC_EMAIL: 'Email PEC',
        ERROR_YOU_CAN_NOT_ENTER_BOTH_PA_CODE_AND_SDI_CODE: 'No puede introducir tanto el código PA como el código SDI',
        ERROR_CODE_MUST_BE_ALPHANUMERIC_CHARACTERS_WITHOUT_SPACES_AND_SPECIAL_CHARACTERS: 'El código {{codeName}} debe ser {{numCharacters}} caracteres alfanuméricos sin espacios ni caracteres especiales',
      },

      FINANCIAL_STATUS: {
        ENTERPRISE_BOOL: 'Empresa activa',
        MASTER_DATA_BOOL: 'Registro correcto',
        ACTIVITY_BOOL: 'Actividad compatible',
        REQUEST_NEW_REPORT: 'Solicitar nuevo informe',
        NO_DATA_TO_SHOW: 'No hay ningún informe existente. Solicita un nuevo informe haciendo clic en el botón de abajo.',
        COLUMNS: {
          DATE: 'Fecha',
          CLASS: 'Clase',
          RISK_DESCRIPTION: 'Descripción de riesgo',
          CREDIT_LIMIT: 'Límite de crédito',
          SCORE: 'Puntuación',
          REPORT: 'Informe',
        },
        REFRESH_MODAL: {
          ARE_YOU_SURE: '¿Está seguro?',
          EACH_REFRESH_HAS_A_COST: 'Cada refresco tiene un coste',
          REFRESH: 'Refrescar',
        },
        PRINT: 'Imprimir',
        SHARE: 'Compartir',
        VIEW_REPORT: 'Ver informe',
      },

      PAYMENT_INFO: {
        CHANNEL_PAYMENTS_TERM_INFO: 'Aquí puede agregar un término de pago específico para cada canal de ventas. Si no se especifica un término de pago para un canal, se utilizará el término de pago predeterminado.',
        ADD_PAYMENT_TERM: 'Añadir término de pago',
        CHANNEL_PAYMENTS_TERM: 'Término de pago del canal',
        PAYMENT_TERM: 'Término de pago',
        DEFAULT_PAYMENT_TERM: 'Término de pago predeterminado',
        CHANNEL: 'Canal',
        BANCK_INFO: 'Información bancaria',
        ABI: 'ABI',
        CAB: 'CAB',
        SWIFT: 'SWIFT',
      },

      COMMERCIAL_AGREEMENT: {
        COMMERCIAL_ALLOWANCE: 'Descuento comercial',
      },

      COMMERCIAL_BLOCK: {
        COMMERCIAL_BLOCK: 'Bloque comercial',
        INFO: 'Al activar el bloqueo comercial en el cliente, nadie excepto los usuarios con roles de storeOwner, storeUser y admin podrán confirmar el carrito.',
        BLOCKED_BY: 'Bloqueado por: {{name}}',
        ALERT_COMMERCIAL_BLOCK_FROM_ERP: 'Este bloque comercial fue implementado por el erp',
      },
    },
    STATUS_LABLE: {
      CREATED_ON: 'Creado el',
      BY: 'por',
      LAST_UPDATE_ON: 'Última actualización el',
      STATUS: 'Estado',
      FOR_CURRENT_STORE: 'Para la tienda actual',
    },
    STATUS: {
      ALL: 'Todos',
      GOK: 'GOK',
      IS_DIRECT: 'Orden directo',
      NOT_GOK: 'No GOK',
      VALID: 'Válido',
      INVALID: 'Inválido',
      TOAPPROVE: 'Para ser aprobado',
      APPROVED: 'Aprobado',
      APPROVED_BY_REQUESTING_USER: 'Aprobado por solicitante',
      APPROVED_GRAPHICALLY: 'Aprobado gráficamente',
      REJECTED: 'Rechazado',
      BLOCKED: 'Bloqueado',
      COMMERCIALBLOCKED: 'Bloqueado',
      PARTIALLY_FULFILLED: 'Parcialmente cumplido',
      ONHOLD: 'En espera',
      BILLING: 'Facturación',
      SHIPPING: 'Envío',
      CUSTOMER: 'Cliente',
      AGENCY: 'Agencia',
      ADMIN: 'Administrador',
      UNASSIGNED: 'Sin asignar',
      ACTIVE: 'Activo',
      INVITED: 'Invitado',
      DISABLED: 'Deshabilitado',
      DRAFT: 'Borrador',
      DRAFT_WITHOUT_NOTIFICATION: 'Borrador',
      DRAFT_WITH_NOTIFICATION: 'Borrador con notificación',
      CREATED: 'Creado',
      CONFIRMED: 'Listo para el fulfil',
      FAILED: 'Fallado',
      RE_ORDER: 'Re-order',
      RESTOCK: 'Reabastecimiento',
      ITEMEXCHANGE: 'Intercambio de artículos',
      PRE_ORDER: 'Pre-order',
      BY_VALUE: 'Por valor',
      BY_QUANTITY: 'Por cantidad',
      BOTH: 'Ambos',
      EXTERNAL_ID: 'ID externo',
      UNCONSTRAINED: 'Sin restricciones',
      BY_ORDER_TOTAL_AMOUNT: 'Gasto mínimo',
      BY_ORDER_TOTAL_QUANTITY: 'Cantidad mínima',
      DELIVERED: 'Entregado',
      SHIPPED: 'Enviado',
      PENDING: 'Pendiente',
      CANCELLED: 'Cancelado',
      CONCLUDED: 'Cumplido',
      PARTIAL: 'Parcial',
      EXPIRED: 'Expirado',
      INACTIVE: 'Inactivo',
      AWAITING_PROCESSING: 'En espera de procesamiento',
      PROCESSING: 'Procesando',
      PROCESSED: 'Procesado',
      PROCESSED_WITH_ERRORS: 'Procesado con errores',
      PROCESSED_WITH_ISSUES: 'Procesado con problemas',
      PROCESSING_FAILURE: 'Error de procesamiento',
      ARCHIVED: 'Archivado',
      SYNCING: 'En sincronización',
      SINGLE_ORDER: 'Pedido único',
      MULTIPLE_ORDERS: 'Pedidos múltiples',
    },
    CHANGES_HANDLER: {
      DATE_UNSAVE_CHANGES: 'No se han guardado los cambios',
      UNDO: 'Deshacer',
      SAVE: 'Guardar',
      IF_YOU_HAVE_PENDING_CHANGES_YOU_WILL_LOSE_THEM: 'Si tiene cambios pendientes, perderá todos',
    },
    CART: {
      ERROR_DIALOG: {
        TITLE: 'Artículos no disponibles',
        UPDATE_DATES: 'Actualizar fechas',
        UPDATE_DATES2: 'Actualizar fechas y eliminar variantes no disponibles',
        UPDATE_DATES3: 'Actualizar solo fechas',
        UPDATE_DATES4: 'Actualizar las fechas y eliminar variantes no disponibles',
        INVALID_DATES: 'Fechas no válidas',
        VARIANT_UNAVAILABLE: 'Variantes no disponibles',
        DELETE_ITEMS: 'Eliminar no disponible',
        LIMIT: 'Límite',
        STOCK_QTY: 'Qty stock',
        ORDERED_QTY: 'Qty ordenada',
        AVAILABLE_QTY: 'Qty disponible',
        CART_QTY: 'Qty en carrito',
        POS_LIMIT: 'Límite de la tienda',
        SKU: 'Sku code',
        COLOR: 'Color',
        PRODUCT: 'Producto',
        SIZE: 'Talla',
        NEW_DATE: 'Nueva fecha',
        MESSAGE1: 'Los siguientes artículos ya no están disponibles para la fecha de entrega solicitada, pero están disponibles para una nueva fecha.',
        MESSAGE1_REORDER: 'Los siguientes artículos tienen fechas de entrega vencidas.',
        MESSAGE1_REORDER2: 'Los siguientes artículos ya no están disponibles para la fecha de entrega solicitada pero están disponibles para una nueva fecha.',
        MESSAGE2: '¿Quieres actualizar las fechas de entrega?',
        MESSAGE3: 'Algunos artículos de pedido ya no se publican o disponible. ¡Estos serán eliminados del carrito!',
        MESSAGE4: '¡Atención! Ha superado el límite de las siguientes combinaciones de estilo y color. Por favor revise su carrito para poder confirmarlo.',
        MESSAGE5: '¡Atención! Ha superado el límite de la tienda actual! Por favor revise su carrito para poder confirmarlo.',
        MESSAGE6: '¿Quieres actualizar la fecha de entrega?',
        MESSAGE_MIN_QTY_PER_ORDER: '¡Atención! ¡Algunos artículos del pedido no alcanzan la cantidad mínima requerida para ese estilo-color específico!',
        MINIMUM: 'Mínimo',
        ERROR_REASON: 'Motivo del error',
        REASON: {
          REQUESTED_QTY_NOT_AVAILABLE: 'La cantidad solicitada no está disponible',
          VARIANT_NOT_AVAILABLE_IN_YOUR_TIER: 'Variante no disponible en tu tier',
          VARIANT_NOT_AVAILABLE_IN_YOUR_CHANNEL: 'Variante no disponible en tu canal',
          VARIANT_NO_LONGER_VISIBLE: 'Variante ya no visible',
          BLANK_CELL_DATE_NO_LONGER_ACTIVE: 'Blank cells, fecha no más activa',
        }
      },
      ATTENTION: '¡Atención!',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_CUSTOMER_IS_NOT_APPROVED: 'No puedes confirmar este carrito porque el cliente no está aprobado',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_POINT_OF_SALE_IS_NOT_APPROVED: 'No puedes confirmar este carrito porque el punto de venta no está aprobado',
      YOU_CANT_CONFIRM_THIS_CART_BECAUSE_LOWER_CART_VALUE: 'No puede confirmar este carrito porque el total del carrito es menor que el valor mínimo permitido en esta tienda',
      THIS_CART_NOT_AVAILABLE: 'Questo carrello non è più disponibile',
      NO_PRODUCTS_IN_CART: 'No hay productos en el carrito',
      COMMERCIAL_BLOCK_INFO: 'Un bloque comercial está activo en el cliente actual.',
      NO_CART_CONF: 'Este carrito no se puede confirmar.',
      DETAILS: {
        ADDRESS_INFO: 'Información de Dirección',
        POS: 'Punto de venta',
        SHIPPING: 'Enviar a',
        ALTERNATIVE: 'Seleccionar una dirección alternativa',
        REMOVE_CUSTOM: 'Borar fecha de entrega',
        SET_CUSTOM: 'Establecer fecha de entrega personalizada',
        INVALID_SELECTION_FOR_CUSTOM_DATES: 'No puede establecer las mismas fechas de entrega personalizadas para los mismos SkuCodes pedidos con diferentes fechas de entrega sugeridas',
        CUSTOM_DATES: 'Fechas de entrega personalizadas',
        SELECT_ALL: 'Seleccionar todo',
        DESELECT_ALL: 'Deseleccionar todo',
        SHIPPING_UPDATED: 'Dirección de envío actualizada',
        NO_OTHER_SHIPPING_ADDRESS_AVAILABLE: 'No hay más direcciones de envío disponibles',
        VARIANTS_ALREADY_ORDERED_WITH_REORDER_DATE: ' artículos no agregados porque ya están en el carrito con fecha de vencimiento. Ve al carrito para gestionarlos.',
        PLEASE_SAVE_OR_CANCEL_YOUR_ORDER_CHANGES: 'Por favor, guarde o cancele sus cambios de pedido',
        STYLE_COLOR_QUANTITY_NOT_RESPECTED_MINIMUM: 'Uno o más artículos no cumplen con la cantidad mínima de pedido',
        SEASON_REFERENCE: 'Season Reference',
        GOK: 'GOK',
        TOTAL_COST: 'Costo total',
        TOTAL_MARGIN: 'Margen total',
        TOTAL_DISCOUNT_PERCENTAGE_FROM_RETAIL: 'Descuento del precio minorista',
        NOTE: 'Nota',
      },
      CONTROLLERS: {
        DELETE: 'Borrar carrito',
        DUPLICATE: 'Duplicar carrito',
        NOTES: 'Notas',
        PRINT: 'Imprimir',
        ACTIONS: 'Acciones',
        CONFIRM_ORDER: 'Confirmar orden',
        OPEN_IN_BACKOFFICE: 'Abrir en backoffice',
        CANCEL_CHANGES: 'Anular cambios',
        SAVE_CHANGES: 'Guardar cambios',
        EDIT_QTY: 'Editar cantidad',
        COMMERCIAL_AGREEMENT: 'Acuerdo comercial',
        VIEW_IN_BACK_OFFICE: 'Ver carrito en Back Office'
      },
      SELECTORS: {
        SHIPPING: {
          TITLE: 'Enviar a',
          TEXT: 'Dirección de envío',
          INPUT: 'Seleccionar dirección de envío',
          DELIVERY_DATES: 'Fechas de entrega del envío'
        },
        DELIVERY: 'Fecha de entrega',
        PRICE: {
          TITLE: 'Totales',
          TOT_WHOLESALE_GROSS: 'Wholesale Gross',
          TOT_DISCOUNT: 'Descuento',
          TOT_DISCOUNT_PERC: 'Descuento %',
          COMM_AGR_DISCOUNT_PERC: 'Descuento ac. comm. %',
          TOT_WHOLESALE_NET: 'Wholesale Neto',
          TOT_RETAIL_NET: 'Retail',
          TOTAL_CART: 'Tot. carrito'
        },
        ADDING_INFO: 'Estás añadiendo {{totalPcs}} unidades, con un valor total al por mayor de €{{totalWholesale}}',
        ADDING_INFO_LOADING: 'Estás añadiendo...',
        QUANTITY: 'Cantidad',
        DISCOUNT: {
          TITLE: 'Tu descuento',
          TEXT: 'Tu descuento'
        },
        PAYMENT: {
          TITLE: 'Método de pago',
          SUB_TITLE: 'Método de pago'
        },
        BILLING: {
          TITLE: 'Información de facturación',
          SUB_TITLE_CUSTOMER: 'Cliente',
          SUB_TITLE_ADDRESS: 'Dirección de envio'
        }
      },
      PRODUCT: {
        TITLES: {
          NAME: 'Nombre del producto',
          WHOLESALE: 'Tot. wholesale',
          QUANTITY: 'Tot. cantidad'
        },
        DOT_MENU: {
          REMOVE: 'Borrar',
          REMOVE_LINE: 'Establezca la cantidad de filas en 0'
        },
        ERRORS: {
          UNAVAILABLE: 'talla no disponible',
          UNAVAILABLES: 'tallas no disponibles'
        }
      },
      CHECKOUT: {
        YOUR_ORDER: 'Tu pedido',
        HAS_BEEN_CONFIRMED: 'está confirmado',
        POINT_OF_SALE: 'Punto de venta',
      },
      PROMOTION: 'Promociones aplicadas',
      ORDER_NOTES: 'Notas del pedido',
    },
    ON_BACK: {
      MODAL: {
        TITLE: 'Los cambios no se han guardado',
        MESSAGE: 'Si sales de esta página, todos los cambios no guardados se perderán.',
        LEAVE_PAGE: 'Salir',
        CONTINUE: 'Continuar',
      }
    },
    FINANTIAL_RISK: {
      FINANTIAL_RISK_CURRENT: 'Riesgo financiero actual',
      FINANTIAL_RISK_PREVIUS: 'Riesgo financiero anterior',
      CLASS: 'Clase',
      SCORE: 'Puntuación',
      DESCRIPTION: 'Descripción',
      SUMMARY: 'Resumen',
      CREDIT_LIMIT: 'Límite de crédito',
      INSOLVENCY: 'Insolvencia',
      COMPANY_INSOLVENCY: 'Insolvencia de la empresa',
      PROTESTI: 'Protestos',
      PREJUDICIALS: 'Prejudiciales',
      NAME: 'Nombre',
      LEGAL_FORM: 'Forma legal',
      TAX_CODE: 'Código fiscal',
      VAT_CODE: 'Código IVA',
      COMPANY_NUMBER: 'Número de empresa',
      EMAIL: 'Email',
      COUNTRY: 'País',
      COMPANY_REG_NUMBER: 'Número de registro de empresa',
      PUBLIC_REG_SECTION: 'Sección de registro público',
      INCORPORATION_DATE: 'Fecha de incorporación',
      REA_REGISTRATION_DATE: 'Fecha de registro REA',
      STATUS: 'Estado',
      STATUS_DESCRIPTION: 'Descripción del estado',
      EMPLOYESS: 'Empleados',
      TURNOVER: 'Facturación',
      ACTIVITY_CODE: 'Código de actividad',
      ACTIVITY_DESCRIPTION: 'Descripción de la actividad',
      COMPANY_DETAILS: 'Detalles de la empresa',
      STATUS_AND_KEY_FIGURES: 'Estado y cifras clave',
      ACTIVITY_DETAILS: 'Detalles de la actividad',
      TELEPHONE: 'Teléfono',
      ADDRESS: 'Dirección',
      LAST_RATING_CHANGE_AT: 'Último cambio de calificación el',
      TYPE: 'Tipo',
    },
    IMPORT_PRODUCT_MODAL: {
      RETAIL_DISCOUNT_PERCENTAGE: 'Porcentaje de descuento del retail',
      DISCOUNT_REQUIRED: 'El descuento es requerido',
      MAX_DISCOUNT_ALLOWED: 'El descuento máximo permitido es de {{value}}%',
    },
    LOCALIZED_TEXT_EDITOR: {
      ACTIONS: 'Acciones',
      ACTION: {
        SET_DEFAULT: 'Establecer predeterminado',
      },
      DEFAULT_LANGUAGE: 'Idioma predeterminado',
    },
    OPERATION_LOG: {
      TITLE: 'Registro de operaciones de ERP para {{value}}',
      OPERATION_LOGS: 'Registro de operaciones',
      ORDER: 'pedido #{{value}}',
      FULFILLMENT: 'entregas #{{value}}',
      LOG_DESCRIPTION: 'Descripción del registro',
      COLUMNS: {
        CREATION_DATE: 'Fecha de creación',
        OPERATION_TYPE: 'Tipo de operación',
        OUTCOME: 'Resultado',
      },
      OPERATION_TYPE_STATUS: {
        CONFRIMED_ORDER: 'Pedido confirmado',
        FULFILLMENT_CANCELED: 'Entrega cancelada',
        ORDER_ITEMS_INSERTED: 'Artículos insertados',
        ORDER_ITEMS_UPDATED: 'Artículos actualizados',
        ORDER_UPDATED: 'Pedido actualizado',
        SERVICE_ITEM_INSERTED: 'Servicio insertado',
        SERVICE_ITEM_UPDATED: 'Servicio actualizado',
        SERVICE_ITEM_DELETED: 'Servicio eliminado',
        FULFILLMENT_CREATED: 'Entrega creada',
        FULFILLMENT_UPDATED: 'Entrega actualizada',
        FULFILLMENT_PACKAGE_CREATED: 'Paquete de entrega creado',
        FULFILLMENT_PACKAGE_ITEM_CREATED: 'Artículo añadido al cuello.',
        ORDER_HEADER_UPDATED: 'Cabecera del pedido actualizada',
        BULK_ADD_ITEMS: 'Artículos añadidos',
        BULK_CHANGE_QTY: 'Cantidad modificada',
        BULK_REPLACE_ITEMS: 'Artículos reemplazados',
        BULK_CHANGE_WHOLESALE: 'Precios modificados',
        BULK_CHANGE_DELIVERY_DATE: 'Fecha de entrega modificada',
        WEBHOOK_NOTIFICATION: 'Webhook enviado al ERP',
        ORDER_SYNC_STATUS: 'Estado del pedido actualizado',
        CHANGE_CUSTOMER_OR_POS: 'Cliente/punto de venta modificado',
        BULK_CANCEL_ORDER: 'Pedidos anulados',
        BULK_OPERATION_ROLLBACK: 'Reversión de operación',
        BULK_REMOVE_ITEMS: 'Artículos eliminados',
      },
      OUTCOME_STATUS: {
        SUCCESS: 'Éxito',
        FAILED: 'Fallido',
      },
    },
    CUSTOMIZATION_REQUEST: {
      CREATE_NEW_CART: 'Crear nuevo carrito desde CR',
      PLAYERS: 'Información de jugadores',
      NO_PLAYERS: 'No se ingresó información del jugador para esta solicitud de personalización',
      NO_PLAYERS_TO_EDIT: 'No hay jugadores que modificar para este producto.',
      TITLE: 'Solicitud de personalización: {{name}}',
      SUCCESSFULLY_SAVED: 'Configuración guardada con éxito',
      HEADER: {
        TITLE: 'Título',
        CUSTOMER: 'Cliente',
        REQUESTER: 'Solicitante',
        CUSTOMER_REQUESTER: 'Solicitante Cliente',
        AGENCY_REQUESTER: 'Solicitante Agencia',
        DESIGNER: 'Diseñador',
        POINT_OF_SALE: 'Punto de venta',
        CUSTOMIZATION_REQUEST_CREATION: 'Creación SP.',
        PERSONALIZED_COST: 'Costo de personalización',
        DISCOUNT: 'Porcentaje de descuento que se aplicará al carrito',
        ENDORSEMENT_REQUESTER: 'Aprobación solicitante',
        ENDORSEMENT_DESIGNER: 'Aprobación diseñador',
        ENDORSEMENT_COMMERCIAL: 'Aprobación comercial',
        REQUEST_REJECTED: 'Rechazada',
        APPROVED_BY_AT: 'Aprobado por {{name}} el {{date}}',
        REJECTED_BY_AT: 'Rechazado por {{name}} el {{date}}',
        PENDING: 'Pendiente',
        SUPPORT_PHONE: 'Teléfono de soporte',
        SUPPORT_EMAIL: 'E-mail de soporte',
        TOTAL_QUANTITY: 'Cantidad total',
        DELIVERY_DATE: 'Fecha de entrega',
        LAST_DESIGNER_NOTIFICATION: 'Última notificación al diseñador',
        TITLE_UPDATED_SUCCESSFULLY: 'Título actualizado exitosamente',
        REQUESTER_UPDATED_SUCCESSFULLY: 'Solicitante actualizado exitosamente',
        DESIGNER_UPDATED_SUCCESSFULLY: 'Diseñador actualizado exitosamente',
        POINT_OF_SALE_UPDATED_SUCCESSFULLY: 'Punto de venta actualizado exitosamente',
        ARE_YOU_SURE_DUPLICATE: '¿Estás seguro de que quieres duplicar la solicitud de personalización',
      },
      REQUESTER_APPROVAL: {
        CHOOSE_TITLE: "¿Quieres ingresar la información de los jugadores de tu equipo?",
        CHOOSE_DONT_CUSTOMIZE: "No, no quiero personalizar",
        CHOOSE_CUSTOMIZE: "Sí, quiero ingresar los nombres y números de mis jugadores (opcional)",
        HOW_MANY: "¿Cuántos jugadores quieres ingresar?",
        SIZES_TITLE: "Ingresa las cantidades para cada producto. Recuerda, tienes un mínimo de {{min}} piezas para cada producto",
        EXTRA_SIZES_TITLE: "Ingresa cantidades adicionales no personalizadas",
        EXTRA_SIZES_TITLE2: " (opcional)",
        EXTRA_SIZES_TITLE3: ". Hay {{n}} productos en los que no has alcanzado la cantidad mínima de compra ({{min}} piezas). Ingresa cantidades para alcanzar el mínimo de compra para cada producto.",
        PLAYERS_TITLE: "Selecciona una fuente e ingresa, para cada jugador, nombre (opcional) y número (obligatorio), y selecciona la talla para cada artículo que deseas asociar a ese jugador.",
        NUMBER: "Número",
        JERSEY_TEXT: "Nombre",
        DUPLICATE_PRODUCT: "Duplicar producto",
        DUPLICATE_ARE_YOU_SURE: "¿Estás seguro de que deseas duplicar este producto en tu solicitud de personalización? Si es así, ingresa el nombre del producto en la solicitud y confirma",
        SHOW_PLAYERS_INFO: "Mostrar información de los jugadores",
        FONTS: "Fuentes",
      },

      NEW_REQUESTER_APPROVAL: {
        MODAL_TITLE: "Aprobación de solicitud de personalización",
        MODAL_SUBTITLE: "Define las cantidades del producto y las personalizaciones adicionales opcionales.",
        ALERT_INFO: "Esta solicitud incluye múltiples productos. Para completar la solicitud, debes ingresar las cantidades para cada producto. Las personalizaciones son opcionales. Recuerda, tienes un mínimo de {{min}} piezas para cada producto.",
        PRODUCTS: "Productos",
        INCOMPLETE: "Incompleto",
        COMPLETE: "Completo",
        TOTAL_PIECES: "Total piezas",
        CUSTOMIZED: "Cantidad de producto con personalización",
        WITHOUT_CUSTOMIZATION: "Sin personalización",
        QUANTITY_WITHOUT_CUSTOMIZATION: "Cantidad de producto sin personalización",
        SIZE: "Talla",
        QUANTITY: "Cantidad",
        WS_UNIT: "WS unit",
        CUST_UNIT: "Pers. Unit",
        WS_TOT: "WS tot",
        INSERT: "Insertar",
        CUSTOMIZATION: "Cantidad de producto con personalización",
        FONTS: "Fuentes",
        LOADING_FONTS: "Cargando fuentes...",
        NUMBER: "Número",
        NAME: "Nombre",
        ADD_PLAYER: "Añadir jugador",
        IMPORT_PLAYERS: "Importar jugadores",
        IMPORT_PLAYERS_HINT: "Importar número y nombre de los jugadores ya configurados",
        IMPORT_LAST_CUSTOMIZATION: "Importar última personalización",
        IMPORT_LAST_CUSTOMIZATION_TOOLTIP: "Si están presentes, puede importar el número y el nombre de los últimos jugadores insertados",
        SAVE_APPROVAL: "Guardar aprobación",
        NO_SUMMARY_ROWS: "No hay filas de resumen.",
        BACK_TO_CUSTOMIZATION_REQUEST: "Volver a la solicitud de personalización",
        SIZE_GROUP: {
          ADULT: "Adulto",
          YOUTH: "Juvenil",
          KIDS: "Niños",
        }
      },

      GRAPHICAL_APPROVAL: {
        COLOR_NAME: "Nombre color",
        COLOR_NAME_TOOLTIP: 'Ejemplo: nombre del club {{currentYear}} + propósito (partido, entrenamiento...)',
      },

      ACTION: {
        APPROVE: 'Aprobar',
        EDIT_CUSTOMIZATION_REQUEST_NAME: 'Editar nombre de la solicitud de personalización',
        EDIT_CR_PRODUCT_NAME: 'Editar el nombre del producto en la CR',
        BACK: 'Retour',
        NEXT: 'Próximo',
        APPROVE_GRAPHICALLY: 'Aprobar gráficamente',
        APPROVE_COMMERCIAL: 'Aprobar comercialmente',
        LOCK_CONFIGURATOR: 'Bloquear configurador',
        UNLOCK_CONFIGURATOR: 'Desbloquear configurador',
        REJECT: 'Rechazar',
        DELETE: 'Eliminar',
        DOWNLOAD_REPORT: 'Descargar reporte',
        DOWNLOAD_COLOR_REPORT: 'Descargar reporte de color',
        DOWNLOAD_STORE_ORDERS_ITEMS_REPORT: 'Descargar informe de líneas de pedido',
        DOWNLOAD_STORE_ORDERS_REPORT: 'Descargar informe de pedidos',
        DOWNLOAD_POINTS_OF_SALE_REPORT: 'Descargar informe del punto de venta',

        DUPLICATE_CUSTOMIZATION_REQUEST: 'Duplicar solicitud de personalización',
        CUSTOMIZATION_REQUEST_ENDORSEMENT: 'Aprobación de solicitud de personalización',
        DELETE_CUSTOMIZATION_REQUEST: 'Eliminar solicitud de personalización',
        REJECT_CUSTOMIZATION_REQUEST: 'Rechazar solicitud de personalización',
        INSERT_REJECTION_REASON: 'Insertar motivo del rechazo',
        ARE_YOU_SURE: '¿Estás seguro?',
        ARE_YOU_SURE_YOU_WANT_TO_LOCK_CONFIGURATOR: '¿Estás seguro de que quieres bloquear el configurador?',
        ARE_YOU_SURE_YOU_WANT_TO_UNLOCK_CONFIGURATOR: '¿Estás seguro de que quieres desbloquear el configurador?',
        ARE_YOU_SURE_YOU_WANT_TO_DELETE: '¿Estás seguro de que quieres eliminar la solicitud de personalización?',

        DELIVERY_DATE: 'Fecha de entrega',
        FINANCIAL_DISCOUNT: 'Descuento financiero',
        ADDITIONAL_CUSTOMIZATION_COST: "Costo de personalización en esta solicitud (opcional)",
        CUSTOMIZATION_REQUEST_APPROVED_SUCCESSFULLY: 'Solicitud de personalización aprobada exitosamente',
        CONFIGURATOR_LOCKED_SUCCESSFULLY: 'Configurador bloqueado exitosamente',
        CONFIGURATOR_UNLOCKED_SUCCESSFULLY: 'Configurador desbloqueado exitosamente',
        CUSTOMIZATION_REQUEST_REJECTED_SUCCESSFULLY: 'Solicitud de personalización rechazada exitosamente',
        CUSTOMIZATION_REQUEST_DELETED_SUCCESSFULLY: 'Solicitud de personalización eliminada exitosamente',
        CUSTOMIZATION_REQUEST_DUPLICATED_SUCCESSFULLY: 'Solicitud de personalización duplicada exitosamente',
        REVERT_TO_DRAFT: 'Volver a borrador',
        REVERT_TO_DRAFT_SUCCESSFULLY: 'El estado de la solicitud de personalización se ha modificado con éxito',
        NOTIFY_DESIGNER_READY: 'Notificar al Diseñador',
        DESIGNER_NOTIFIED_SUCCESSFULLY: 'Diseñador notificado exitosamente',
      },
      DETAIL: {
        BACK_TO_CUSTOMIZATION_REQUESTS: 'Volver a las solicitudes de personalización',
        DETAIL: 'Detalle',
        TIMELINE: 'Timeline',
        MEDIA: 'Medios',
        CHANNEL_NAME: 'Nombre del canal',
        STATUS: 'Estado',
        CONFIGURATOR_LOCKED: 'Configurador bloqueado',
        CUSTOMIZED_PRODUCTS: 'Productos personalizados',
        ADD_PRODUCT: 'Agregar producto',
        SELECT_PRODUCT: 'Seleccionar producto',
      },
      MEDIA: {
        FILE_NAME: 'Nombre del archivo',
        USER_NAME: 'Nombre de usuario',
        USER_ROLE: 'Rol de usuario',
        DOCUMENT_GRAPHICAL_APPROVAL: 'Aprobación gráfica del documentos',
        DOWNLOAD_DOCUMENT: 'Descargar documento',
        ATTACHMENTS_OF_CUSTOMIZATION_REQUEST: 'Adjuntos de la solicitud de personalización',
      },
      UPLOAD_FILE: {
        ERROR_FILE_MAX_SIZE: '<strong>¡Error! </strong> El archivo excede el tamaño máximo permitido de {{maxSize}}',
        ERROR_FILE_TYPE: '<strong>¡Error! </strong>El archivo no es de un tipo permitido, los tipos permitidos son: {{allowedTypes}}',
        ATTACH_DOCUMENT: 'Adjuntar documento',
        ATTACH_IMAGE: 'Adjuntar imagen',
        ATTACHMENT: 'Adjunto',
        BROWSE: 'Explorar',
        CHOSE_DOCUMENT: 'Elegir documento',
        CHOSE_IMAGE: 'Elegir imagen',
      },

      CUSTOMIZATION_PRODUCT: {
        PRODUCT_DELETED_SUCCESSFULLY: 'Producto eliminado exitosamente',
        PERSONALIZE: 'Personalizar',
        COLOR_NAME: 'Nombre color',
        COLOR_CODE: 'Código color',
        START_3D_VIEWER: 'Iniciar visor 3D',

        SKU: 'Código producto',
        PRODUCT_NAME: 'Nombre producto',
        TEMPLATE_ID: 'ID de plantilla',
        ID: 'ID',
        WHOLESALE_TOTAL_PRICE: 'Wholesale tot.',

        TABLE: {
          SIZE: 'Tamaño',
          QUANTITY: 'Cantidad',
          WHOLESALE_UNIT_PRICE: 'Wholesale unit.',
          CUSTOMIZATION_UNIT_PRICE: 'Personalización unitario',
          WHOLESALE_TOTAL_PRICE: 'Wholesale tot.',
        }
      },

      TIMELINE: {
        CUSTOMIZATION_REQUEST_CREATED: 'Solicitud de personalización creada',
        CUSTOMIZATION_REQUEST_REJECTED: 'Solicitud de personalización rechazada',
        PRODUCT_ADDED: 'Producto añadido',
        PRODUCT_DELETED: 'Producto eliminado',
        POINT_OF_SALE_UPDATED: 'Punto de venta actualizado',
        CONFIGURATOR_LOCKED: 'Configurador bloqueado',
        CONFIGURATOR_UNLOCKED: 'Configurador desbloqueado',
        STATUS_RESET_TO_DRAFT: 'Estado restablecido a borrador',
        APPROVED_BY_REQUESTER: 'Aprobado por el solicitante',
        APPROVED_GRAPHICALLY: 'Aprobado gráficamente',
        APPROVED_COMMERCIAL: 'Aprobado comercialmente',
        DEFAULT_DESIGNER_ASSIGNED: 'Diseñador predeterminado asignado',
        DESIGNER_REASSIGNED: 'Diseñador reasignado',
        REQUESTER_REASSIGNED: 'Solicitante reasignado',
        CUSTOMER_REQUESTER_REASSIGNED: 'Solicitante cliente reasignado',
        AGENCY_REQUESTER_REASSIGNED: 'Solicitante agencia reasignado',
        MESSAGE_ADDED: 'Mensaje añadido',
        MEDIA_ADDED: 'Medios añadidos',
        DESIGNER_NOTIFIED: 'Diseñador notificado',
        BY: 'por {{name}}',
        HIDE_MESSAGE_FROM_REQUESTER: 'Ocultar mensaje del solicitante',
        READ_MORE: 'Leer más',
        READ_LESS: 'Leer menos',
        FOR_CR_PRODUCT: 'para producto: #{{value}}',
        REQUESTING_NEW_DESIGN: 'con solicitud de nuevo diseño',
        TRANSLATE_MESSAGE: 'Traducir mensaje',
        SHOW_ORIGINAL_MESSAGE: 'Mostrar mensaje original',
      },
      CONFIGURATOR: {
        BACK_TO_CUSTOMIZATION_REQUEST: 'Volver a la solicitud de personalización',
        PRODUCT_CONFIGURATOR: 'Configurador de producto #{{sku}} - {{title}}',
      },
    },
    // TRADUZIONI CROSS FRONT / BACK OFFICE
    DUPLICATE_CART: {
      TITLE: 'Duplicar carrito',
      CUSTOMER: 'Cliente',
      POINT_OF_SALES: 'Punto de venta',
      CART_NAME: 'Nombre del carrito',
      ALTERNATIVE_SHIPPING_ADDRESS: 'Dirección de envío alternativa',
      SUCCESS_CART_DUPLICATED: 'Carrito duplicado correctamente',
      ERROR_CART_DUPLICATED: 'Error al duplicar uno o más productos',
      DUPLICATE_CART: 'Duplicar carrito',
      SET_REQUEST_DELIVERY_DATE: 'Establecer fecha de entrega',
      AGENCY: 'Agencia',
      CART_DUPLICATED_PARTIALLY: 'Carrito duplicado parcialmente',
      CART_NOT_DUPLICATED: 'Carrito no duplicado',
      VARIANTS_NOT_ADDED: 'Variantes no añadidas',
      VARIANT: 'Variante',
      VARIANT_NOT_AVAILABLE: 'variante no disponible',
      QUANTITY_INSUFFICIENT: 'cantidad insuficiente',
      REQUESTED_QUANTITY: 'cantidad solicitada',
      AVAILABLE_QUANTITY: 'cantidad disponible',
      MANUAL_DISCOUNT: 'Incluir descuentos aplicados manualmente',
      PENDING_FULFILLMENT: 'Duplicar solo artículos de pedidos no cumplidos',
      OPTION_DUPLICATE_ORDER: 'Opciones de duplicación de pedido',
      INCLUDE_CUSTOM_DELIVERIES: 'Incluir entregas personalizadas',
      SKIP_CHECKS: 'Excluir los controles de visibilidad y cantidad',
    },
    CHANNEL: {
      BROWSE: 'Navegar',
      TITLE: 'Channel',
    },

    CONFIRM_CART_MODAL: {
      TITLE: 'Confirmar carrito',
      SUB_TITLE: 'Estás confirmando el carrito',
      ATTENTION_THIS_CUSTOMER_HAVE_A_COMMERCIAL_BLOCK_ACTIVE: 'Este cliente tiene un bloqueo comercial activo. ¿Está seguro de que desea confirmar el pedido de todos modos?',
      YOU_HAVE_VOUCHERS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Tiene voucher disponibles que puede aplicar a este carrito',
      NO_ENTERED_ATTACHMENTS: 'No hay attachments insertados',
      SELECT_VOUCHER: 'Seleccione un voucher',
      RESIDUAL_VOUCHER_VALUE: 'Valor residual del voucher: {{value}}',
      TOTAL_CART: 'Total carrito: {{value}}',
      TERMS_AND_CONDITIONS: 'Términos y condiciones',
      ACCEPT_TERMS_AND_CONDITIONS: 'Acepto los términos y condiciones',
      NO_VOUCHERS_AVAILABLE: 'No hay vouchers disponibles',
      VOUCHERS_UNAVAILABLE: 'La función de cupón no está disponible temporalmente',
      CONFIRM: 'Confirmar',
      COMMERCIAL_AGREEMENT: 'Acuerdo comercial',
      YOU_HAVE_COMMERCIAL_AGREEMENTS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'Tiene acuerdos comerciales disponibles que puede aplicar a este carrito',
      SELECT_COMMERCIAL_AGREEMENT: 'Seleccione un acuerdo comercial',
      DISCOUNT: 'Descuento',
      COMMERCIAL_AGREEMENT_ID_IS_NOT_VALID: 'El acuerdo comercial previamente asociado a este carrito ya no es válido. Seleccione otro o elimine el anterior',
      REMOVE_COMMERCIAL_AGREEMENT: 'Eliminar acuerdo comercial',
      YOU_DONT_HAVE_COMMERCIAL_AGREEMENTS_AVAILABLE_THAT_YOU_CAN_APPLY_TO_THIS_CART: 'No tienes acuerdos comerciales disponibles que puedas aplicar a este carrito',
      SAVE: 'Ahorrar',
      MANAGE_DELIVERY_DATES: 'Gestionar fechas de entrega',
      OPTION_TITLE: 'Opciones de confirmación',
      EXCLUDE_CONTROLS: 'Excluir controles de visibilidad y cantidad',
      INFO_EXCLUDE_CONTROLS: 'Al excluir las comprobaciones de visibilidad y cantidad, puede confirmar la cesta incluso si los artículos no están visibles o si la cantidad solicitada no está disponible.',
      DONT_SENT_EMAIL: 'No enviar correo de confirmación',
      POPULATE_DEFAULT_RECIPIENTS: 'Rellenar con destinatarios predeterminados',
    },

    PAGINATION: {
      ITEM_FOR_PAGE: 'Elementos por página',
      PAGE: 'Página',
      OF: 'de',
    },

    EVALUATE_CART_SALE_CAMPAIGN_CONSTRAINT: {
      COMMERCIAL_RULES: 'Reglas comerciales',
      ALERT: {
        TITLE: '¡Atención!',
        MESSAGE: 'Se ha activado en este carrito la regla comercial "{{commercialRuleName}}" para la campaña de ventas "{{saleCampaignName}}".',
        MORE_INFO: 'Mostrar detalles',
        CLICK_HERE_FOR_MORE_INFO: 'Haga clic aquí para mostrar detalles',
        CART_NOT_CONFIRMABLE: 'Hay una regla de negocio activa en este carrito para la cual no se cumplen una o más restricciones',
        FOR_CONFIRM_CART: ',para confirmarlo, se deben satisfacer todas las restricciones.',
        ROLE_BYPASS: 'Su función le permite confirmar el carrito incluso si no se cumplen todas las restricciones.',
        CONSTRAINTS_IS_SATISFIED: 'Hay una regla de negocio activa en este carrito y se cumplen sus restricciones.',
      },

      MODAL: {
        DETAIL_COMMERCIAL_RULE: 'Detalle de la regla comercial: {{commercialRuleName}}',
        MISSING_ITEMS_OF_PRODUCTS: 'Te faltan {{missingNumberOfItems}} piezas entre los productos: {{stylesCode}}',
        VALUE_CONSTRAINT_NOT_REACHED: "Los artículos de este surtido no alcanzan el porcentaje mínimo en comparación con el total al por mayor, considerando también los pedidos anteriores realizados en la campaña de ventas actual (total al por mayor {{computedTotalWholesaleForMatchedItems}}€, correspondiente al {{computedPercentageOfTotalWholesaleForMatchedItems}}%, mientras que el umbral es del {{constrainedTotalWholesaleMinimumPercentage}}%; faltan €{{missingWholasale}})",
        VALUE_CONSTRAINT_REACHED: 'Restricción de valor satisfecho',
        VALUE_CONSTRAINT: '({{computedTotalWholesaleForMatchedItems}}€, correspondiente al {{computedPercentageOfTotalWholesaleForMatchedItems}}%)',
        ALL_PACKAGE_CONSTRAINTS_ARE_SATISFIED: 'Restricciones del paquete satisfechas',
        CONSTRAINTS_ON_ASSORTMENT: 'Restricciones de surtido: {{assortmentName}}',
      },
    },

    CUSTOM_SHIP_DATES: {
      ITEMS_WITH_NO_STOCK1: 'Algunas fechas no se han añadido: ',
      ITEMS_WITH_NO_STOCK2: ' artículos no tienen cantidad disponible en stock',
      TITLE: 'Fechas de envío personalizadas',
      SELECT_ALL: 'Seleccionar todo',
      UNSELECT_ALL: 'Deseleccionar todo',
      APPLY: 'Aplicar',
      BULK_PERSONALIZED_DATE: 'Personaliza las fechas de entrega ({{numberOfItems}})',
      CUSTOM_DATE: 'Fecha personalizada',
      DATE_NOT_SELECTABLE: 'Fecha no seleccionable',
      REMOVE_ALL_CUSTOM_DATES: 'Eliminar fechas personalizadas',
      DATE_OVER_MAX_DATE: 'Uno o más artículos tienen una fecha personalizada que excede la fecha máxima de personalización establecida en esta tienda',
      REQUESTED_DATE_OVER_MAX_DATE: 'Uno o más artículos seleccionados no son personalizables porque la fecha de entrega solicitada original excede la fecha máxima de personalización establecida en esta tienda',
      ON: 'el',
      FROM: 'de',
      TO: 'a',
      ADD_NEW_DATE: 'Añadir nueva fecha',
      DATE: 'Fecha',
      QTY: 'Qty pedida',
      ERROR_THE_SUM_OF_THE_QUANTITIES_FOR_CUSTOM_DATES_IS_GREATER_THAN_THE_QUANTITY_ORDERED: '¡Error! La suma de las cantidades para las fechas personalizadas es mayor que la cantidad ordenada',
      ERROR_THE_SUM_OF_THE_QUANTITIES_FOR_CUSTOM_DATES_IS_LESS_THAN_THE_QUANTITY_ORDERED: '¡Error! La suma de las cantidades para las fechas personalizadas es menor que la cantidad ordenada',
      ERROR_THERE_ARE_DUPLICATE_DATES: '¡Error! Hay fechas duplicadas',
      ERROR_THE_CURRENT_DATE_IS_OVER_THE_MAX_DATE: '¡Error! La fecha actual es mayor que la fecha máxima',
      INFO_MODAL_TITLE: 'Nueva modalidad de personalización de fechas de entrega',
      INFO_MODAL_CONTENT: 'Personalizar las fechas de entrega de los artículos dentro de un carrito ahora está disponible a través de la ventana de confirmación del pedido (ver captura de pantalla a continuación). Ya no será posible realizar esta operación utilizando las acciones utilizadas hasta ahora.',
      OK: 'Entendí'
    },


    CUSTOMIZATION_REQUEST_CREATOR: {
      PERSONALIZE: 'Personalizar',
      BACK: 'Volver',
      CONFIRM: 'Confirmar',
      REQUEST_CONFIGURATION: 'Solicitar nuevo design',
      DOWNLOAD_THUMBNAIL: 'Descargar miniatura',
      SAVE: 'Guardar',
      CHANGE_TEMPLATE: 'Cambiar plantilla',
      CREATED_SUCCESSFULLY: 'Solicitud de personalización creada exitosamente',
      PRODUCT_ADDED_SUCCESSFULLY: 'Producto añadido exitosamente',
      STEP_1: {
        TITLE: 'Nueva personalización',
        MESSAGE: '¿Desea crear una nueva solicitud de personalización o usar una ya existente?',
        NEW_CR: 'Nueva solicitud',
        EXISTING_CR: 'Solicitud existente',
      },
      STEP_2: {
        TITLE: 'Nueva solicitud de personalización',
        SELECT_REQUESTER: 'Selecciona al menos un solicitante. Puedes seleccionar un cliente y/o un agente',
        SELECT_REQUESTER_2: 'Como usuario de una agencia, puedes vincular esta solicitud de personalización también a un cliente',
        SELECT_REQUESTER_3: 'Como usuario de un cliente, puedes vincular esta solicitud de personalización también a un agente, si tu punto de venta es gestionado por una agencia',
        TITLE_REQUEST: 'Título de la solicitud',
        TITLE_REQUEST_TOOLTIP: 'Ejemplo: nombre del club {{currentYear}}.',
        COMMENTS: 'Nombre del producto en la solicitud',
        COMMENTS_TOOLTIP: 'Ejemplo: nombre del club + propósito (partido, entrenamiento...)',
      },
      STEP_3: {
        TITLE: 'Seleccionar la solicitud de personalización',
        SELECT_REQUEST: 'Seleccionar solicitud',
      },
      STEP_4: {
        TITLE: 'Seleccionar una plantilla base',
        DESCRIPTION: 'Solicitud de personalización: {{name}}',
      },
      STEP_5: {
        TITLE: 'Solicitar configuración para la personalización: {{name}}',
        DESCRIPTION: 'Plantilla #{{expiviId}}',
      },
      STEP_6: {
        TITLE: 'Configuración para la solicitud: {{name}}',
        DESCRIPTION: 'Plantilla #{{expiviId}}',
      },

      CONFIGURATION_MESSAGE: {
        PLACEHOLDER: 'Describa el producto que le gustaría solicitar',
        MESSAGE_OF_REQUEST: 'Mensaje de solicitud',
        ATTACHMENTS: {
          TITLE: 'Adjuntos',
          ADD: 'Agregar adjunto',
        },
      },

      VALIDATION: {
        AT_LEAST_ONE_REQUESTER: 'Por favor seleccione al menos un solicitante (Cliente o Agencia)',
        REQUESTERS_MUST_BE_DIFFERENT: 'El solicitante Cliente y el solicitante Agencia deben ser usuarios diferentes',
      },

    },
    BASIC_KUSTOM_REQUESTER: {
      CUSTOMER: 'Cliente',
      AGENT: 'Agente',
      CUSTOMER_REQUESTER: 'Solicitante Cliente',
      SELECT_AGENCY: 'Seleccionar agencia',
      SELECT_AGENT: 'Seleccionar agente',
      THIS_POINT_OF_SALES_DOES_NOT_HAVE_ANY_AGENCY: 'Este punto de venta no tiene ninguna agencia',
    },

    //shop

    POS_STOCK_INFO: {
      TITLE: 'Info sobre el stock del punto de venta',
      LOADING: 'Cargando stock info..',
      ORDERABLE_QTY: 'Cantidad ordenable para el punto de venta actual',
      ORDERABLE_QTY2: 'En el carrito actual puedes añadir más',
      CART_QTY: 'Cantidad en el carrito actual',
      TOTAL: 'Total'
    },
    COMMON: {
      SET: 'Set',
      SAVE: 'Guardar',
      MIN: 'Min',
      MAX: 'Max',
      FROM: 'Desde',
      TO: 'Hasta',
      SHOW: 'Mostrar',
      ONLY: 'Solo',
      IN: 'en',
      SHOW_ONLY: 'Mostrar solo',
      SHOW_MORE: 'Mostrar más',
      SUGG_RETAIL: 'Sug. retail',
      SEARCH: 'Buscar',
      DATES_CHECKBOX: 'Mostrar solo semanas con porductos disponibles',
      DELIVERY_DATES: 'Fechas de entrega',
      PCS: 'pcs',
      WHOLESALE: 'Wholesale',
      SUGGESTED: 'Sugerido',
      VALID: 'Validar',
      TYPE: 'Tipo',
      EXPAND_ALL: 'Mostrar todo',
      COLLAPSE_ALL: 'Collapse todo',
      PRODUCTS: 'Productos',
      COMMERCIAL_BLOCK_ACTIVE: 'Bloqueo comercial activo',
      MAN: 'Hombre',
      WOMAN: 'Mujer',
      UNISEX: 'Unisex',
    },
    HEADER: {
      PRE_ORDER: 'Pre-order',
      RE_ORDER: 'Re-order',
      MY_CARTS: 'Mis carritos',
      CART: 'Carrito',
      CARTS: 'Carritos',
      SELECT_CHANNEL: 'Seleccionar channel'
    },
    ACCOUNT_POPUP: {
      MY_ACCOUNT: 'Mi cuenta',
      BACK_OFFICE: 'Back-office',
      LOGOUT: 'Logout',
      SWITCH_TENANT: 'Cambiar de país',
      CHANGE_LINGUAGE: 'Cambiar idioma',
      SHOW_ONLY_RETAIL_PRICES: 'Mostrar solo precios retail',
    },
    DIALOGS: {
      USE_TIER_FILTER: 'Configurar un filtro según la configuración del nivel',
      NO_TIER: 'Información no asociada a ningún nivel',
      SELECT_TIER: 'Información asociada a un nivel específico',
      ARE_YOU_SURE_YOU_WANT_TO_CONFIRM_THIS_CART_BLOCKED: '¡Atención! este cliente tiene un bloqueo comercial activo. ¿Está seguro de que desea confirmar el pedido de todos modos?',
      DO_YOU_WANT_TO_LOGOUT: '¿Está seguro que quiere salir?',
      DO_YOU_WANT_TO_DELETE_THIS_CART: '¿Está seguro que quiere eliminar este carrito?',
      DO_YOU_WANT_TO_CONFIRM_THIS_ORDER: '¿Quiere confirmar este pedido?',
      DO_YOU_WANT_TO_DELETE: '¿Está seguro que quiere borrar?',
      CREATE_NEW_CART: 'Crear un nuevo carrito',
      CREATE_CART: 'Crear carrito',
      EDIT_CART: 'Editar carrito',
      COPY_CART: 'Copiar carrito',
      TYPE_A_NEW_CART_NAME: 'Escriba...',
      AGENCY: 'Agencia',
      NEW_CART_NAME: 'Nombre del carrito',
      CANT_CONFIRM_THIS_ORDER: 'No se ha podido confirmar este pedido',
      CANCEL: 'Cancelar',
      CONFIRM: 'Confirmar',
      SAVE: 'Guardar',
      GOK_MODE: 'GOK',
      GOK_CART: 'Carrito Gok'
    },
    FOOTER: {
      COPYRIGHT: 'Copyright BasicGroup 2025',
      PRIVACY_POLICY: 'Política de Privacidad',
      TERMS: 'Términos y condiciones',
      TERMS_NOT_FOUND: 'Términos y condiciones no encontrados',
      FOR_CLUBS: 'For clubs',
      NO_DATA: "No hay datos disponibles, contacte al administrador.",
      RESET: 'Resetear contraseña',
      TEXT: 'BasicItalia S.r.l. - Strada della Cebrosa 106, 10100 Torino, Italy - P.IVA e CF IT1234567890',
      BUTTON: 'Ayuda'
    },
    CART_POPUP: {
      CLOSE: 'Cerrar',
      PIECES: 'Piezas',
      PRODUCTS: 'Productos',
      RE_ORDER_CARTS: 'RE-ORDER',
      PRE_ORDER_CARTS: 'PRE-ORDER',
      SELECTED_CURRENT: 'El carrito seleccionado es el carrito con el que está comprando actualmente',
      SELECTED: 'Seleccionado',
      NAVIGATE: 'Ir al carrito',
      DELIVERY_DATES: 'Entrega el',
      WHOLESALE_PRICE: 'Precio wholesale',
      CREATED: 'Creado',
      CONTROLLERS: {
        DELETE: 'Eliminar carrito seleccionado',
        CREATE: 'Crear nuevo carrito',
        GO_TO_CHECKOUT: 'Ir al checkout',
        NO_CARTS: 'No hay carritps, por favor cree uno.'
      }
    },
    FILTERS: {
      STRATEGIC: 'Strategico',
      PROMO: 'En promo',
      CUSTOMIZABLE: 'Personalizables',
      AVAILABLE_NOW: 'Disponible ahora',
      GENDER: 'Género',
      SIZE_GROUP: 'Grupo de tallas',
      Collections: 'Colecciones',
      STYLE_GROUP: 'Grupo de artículo',
      COLORS: 'Colores',
      CATEGORY: 'Categoría',
      PURPOSE: 'Propósitos',
      ASSORTMENTS: 'Surtidos',
      TEAM: 'Equipo',
      SEASON: 'Temporada',
      AVAILABILITY: 'Disponibilidad',
      WHOLESALE_PRICE: 'Precio Wholesale',
      SUGGESTED_RETAIL_PRICE: 'Precio Suggested retail',
      NO_DATA: 'No data',
      TAGS: 'Tags',
      APPLAY_FILTERS: 'Aplicar filtros',
      CLEAR_ALL: 'Limpiar todo',
    },
    SIZE_GROUPS: {
      ADULT: 'Adult',
      YOUTH: 'Youth',
      KID: 'Kid',
      INFANT: 'Infant'
    },
    SIZES_TABS: {
      LIMIT: 'Límite',
      COLOR: 'Color',
      PRICE: 'Precio',
      DOT_MENU: {
        COPY: 'Copiar',
        PASTE: 'Pegar',
        CLEAR_ALL: 'Limpiar todo',
        REMOVE_ALL: 'Borrar todo'
      },
      ADD: 'Añadir al carrito',
      TOT_PCS: 'Total pcs.',
      MAX_QTY_REACHED: 'Cantidad máxima alcanzada',
      QTY_NOT_AVAILABLE: 'Cantidad no disponible'
    },
    BREADCRUMBS: {
      HOME: 'Home',
      RE_ORDER: 're-order',
      PRE_ORDER: 'pre-order',
      CATALOG: 'Catálogo',
    },
    HOME: {
      SHOP: {
        CATALOG: 'Explorar todo el catálogo',
        BROWSE: 'Explorar por'
      },
      CATEGORIES: {
        TITLE: 'Categorías',
        TEXT: 'Compra por categorías y realiza tu pedido en unos pocos clics',
        BUTTON: 'Buscar todo el catálogo'
      },
      VIDEO: {
        TITLE: '¿Qué hay de nuevo esta temporada?',
        TEXT: 'Descubre lo que tenemos para ti esta temporada: productos clave, nuevas tecnologías y mucho más'
      },
      COLLECTIONS: {
        TITLE: 'Surtidos',
        TEXT: 'Explora nuestro amplio rango de surtidos, cuidadosamente elegidos para ti.',
        EXPLORE: 'Descubre todos los surtidos'
      },
      PRODUCTS: {
        TITLE: 'Nuestros productos estratégicos',
        TEXT: 'Descubre cuales productos calve que debes tener de cara a la próxima temporada',
        BUTTON: 'Shop strategic',
        ADD_TO_CART: 'Añadir al carrito'
      },
      PROMOTIONS: {
        TITLE: 'Promociones',
        EXPLORE: 'Descubre todas las promociones'
      },
      SHOWCASE: {
        ALL: 'Todos',
        EXPLORE: 'Explora el catálogo de {{name}}',
        SHOP_NOW: 'Compra ahora',
        DISCOVER_MORE: 'Descubre todos los productos para {{name}}'
      }
    },
    PRODUCTS: {
      LIST: {
        FILTERS: 'Filtros',
        ACTIVE_FILTERS: 'Activar filtros',
        BROWSE_BY: 'Buscar por',
        ITEMS: 'Items',
        ORDER_BY: 'Ordenar por',
        NO_PRODUCTS: 'No hay productos',
        NO_ASSORTMENTS: 'No hay surtidos',
        VIEW: 'Vista',
        GRID: 'Cuadrícula',
        LIST: 'Lista'
      },
      DETAIL: {
        ERROR_VARIANTS_ALREADY_PRESENT: 'Las siguientes variantes ya están en el carrito de compras con una fecha de entrega solicitada diferente a la seleccionada ({{date}}):',
        STYLE_COLOR_QUANTITY_LIMIT_EXCEEDED: 'Está excediendo el límite de cantidad de estilo y color',
        STYLE_COLOR_QUANTITY_NOT_RESPECTED_MINIMUM: 'Está intentando agregar uno o más artículos que no cumplen con la cantidad mínima de pedido',
        PROMO: {
          ORDER: 'Order',
          MORE_OF: 'Más de estos productos para tener un',
          MORE_MORE_OF: 'Más de estos productos para tener un',
          MORE_OF_VALUE: '€ Más de estos productos para tener un',
          DISCOUNT: 'Descuento',
          QUANTITY: 'Cantidad',
          PRICE: 'Precio',
          VIEW_PROMO: 'Ver promo',
          TITLE: 'Promociones',
          PROMOTION_NAME: 'Nombre',
          RANGE: 'Rango de validez',
          TYPE: 'Tipo de promoción',
          VALIDITY_PERIOD: 'Periodo de validez',
          ITEM_IN_YOUR_CART: 'Artículos en su carrito',
          VALUE_IN_YOUR_CART: 'Valor de su carrito',
          INFO_ALLERT: '¡Atención! No se aplicarán promociones en variantes que tengan descuento de canal',
        },
        INFO: {
          SHOP_SELLING_PERIOD: 'Periodo de venta',
          PRICE_LIST: 'Lista de precios'
        },
        ADDITIONAL: {
          PRODUCT_DESCRIPTION: 'Descripción del producto',
          PRODUCT_INFO: 'Info del producto',
          PURPOSE: 'Objetivo',
          DESCRIPTION: 'Descripción',
          SEASON: 'Temporada',
          GENDER: 'Género',
        },
        CS: {
          TITLE: 'Colores y tallas',
          DELIVERY_DATE: 'Fecha de entrega',
          PLACEHOLDER: 'Buscar color'
        },
        CONTROLLERS: {
          CLEAR_ALL: 'Limpiar todas las cantidades',
          ADD_ALL: 'Añadir cantidades al carrito',
          COMPRESS: 'Comprimir',
          EXPAND: 'Expandir',
        },
        NO_AVAILABLE: {
          TEXT: 'Este producto ya no está disponible en pre-order. Por favor, vaya al catálogo de re-order para hacer su pedido.',
          BUTTON: {
            PRE_ORDER: 'Comprar producto en pre-order',
            RE_ORDER: 'Comprar producto en re-order'
          }
        },
        SAME: 'Estilos en el mismo surtido',
        SIMILAR: 'Estilos similares en otros surtidos',
        NO_VARIANTS_PUBLISHED: 'NO HAY VARIANTES PUBLICADAS PARA EL ACTUAL GRUPO DE TALLAS PARA LA FECHA SELECCIONADA',
        ERROR_QUANTITY: '¡Atención! Cantidad solicitada no disponible. Conjunto de cantidad máxima disponible',
      },
      CARD: {
        WHOLESALE: 'Wholesale',
        RETAIL: 'Retail',
        AVAILABILITY: 'piezas en stock'
      }
    },
    ERRORS: {
      TITLE: 'Mensaje de error',
      PRODUCT_LOADING: 'Ocurrió un error al cargar el producto',
      INVALID_ORDER: 'El pedido no es válido',
      DEFAULT_MESSAGE: 'Perdón, algo salió mal. Por favor, inténtelo de nuevo más tarde'
    },
    COLLECTION_CARD: {
      SHOP_ASSORTMENT: 'Descubrir surtido'
    },
    PROMOTION_CARD: {
      SHOP_PROMO: 'Descubrir promoción'
    },

    VARIANT_GRID: {
      CUSTOMER_DISCOUNT: "El cliente para el que estás comprando tiene un descuento de",
      USE_ACTION: "Usar acción",
      USING_PERC: "aplicando directamente el descuento del",
      ADD_DELIVERY_WITH_STOCK: 'Agregar una entrega con cantidad en stock',
      ADD_DATE_WITH_STOCK: 'Agregar una fecha con cantidad en stock',
      QTY_AVAILABLE_IN_STOCK: 'Cant. disp. en stock',
      USE_OLD_VERSION: 'Usar versión anterior',
      USE_NEW_VERSION: 'Usar la nueva versión',
      NEW_SIZE_GRID_NOTICE: 'La nueva tabla de tallas está disponible. Desde aquí puedes elegir qué versión usar.',
      A_CUSTOM_DELIVERY: 'entrega personalizada',
      REORDER_SECTION: 'sección re-order',
      SELECT_COLORS: 'Selecciona colores para ver fechas y cantidades',
      ADD_DELIVERY: 'Agregar entrega personalizada',
      ON_DATE: 'En esta fecha',
      COLORS: 'Colores',
      PCS_ORDERED: 'Piezas ordenadas',
      CUSTOM_ADD: 'Añadido personalizado',
      ADD_QTY: 'Agregar cantidad',
      SELECT_CUSTOM_DELIVERY: 'Selecciona tu entrega personalizada',
      ADD_ITEMS_CUSTOM: 'Agregar artículos con opciones personalizadas',
      CANT_MANAGE_DATES: 'No puedes gestionar las fechas de entrega en',
      DISCOUNT_APPLIED_ALL: 'El descuento se aplicará a cada artículo que estés añadiendo, incluidos aquellos para los que ya se ingresaron cantidades.',
      DIFF_PRICE_WARNING: 'Estás añadiendo artículos con precios diferentes, por lo tanto no puedes establecer un precio mayorista deseado para calcular el descuento.',
      PERCENTAGE: 'Porcentaje',
      DISCOUNT_NAME: 'Nombre del descuento',
      DISCOUNT_TYPE: 'Tipo de descuento',
      DESIRED_WHOLESALE: 'Precio wholesale deseado',
      DISCOUNT_PCT: 'Porcentaje de descuento',
      CLEAR_QUANTITY: 'Limpiar cantidad',
      ADD_ALL: 'Agregar todo',
      ADD: 'Agregar',
      PRE_COMPILE_WITH_AVAILABLE_QTY: 'Prellenar con las cantidades disponibles',
      COPY: 'Copy input values',
      PASTE: 'Paste copied values',
      COPIED: 'Copied values!',
      PASTED: 'Pasted values!',
      ADD_AVAILABLE_QUANTITY: 'Agregar cantidad disponible',
      QTY_AVAILABLE: 'Cantidad disponible',
      QTY_IN_CART: 'Cantidad en carrito',
      THERE_ARE_NO_AVAILABLE_QUANTITIES_TO_ADD: 'No hay cantidades disponibles para agregar',
      MAX_QTY_REACHED: 'Cantidad máxima alcanzada',
      QTY_NOT_AVAILABLE: 'Cantidad no disponible',
      QTY_NOT_AVAILABLE_BY_CLICKING_SAVE_THE_VARIANT_WILL_BE_REMOVED: 'La cantidad no está disponible. Al hacer clic en "Guardar", la variante se eliminará del carrito.',
      LIMIT_EXCEEDED_FOR_PALETTE: 'Límite superado para el color: {{paletteCode}}',
      HAVE_BEEN_PRECOMPILED_CLICK_ON_ADD_TO_ADD_THEM_TO_YOUR_CART: 'Cantidades de color <b>{{colorCode}}</b> han sido precompilados. Haga clic en "Agregar" para agregarlos a su carrito.',
      HAVE_BEEN_PRECOMPILED_CLICK_ON_ADD_TO_ADD_THEM_TO_YOUR_CART_ALL: 'Cantidades disponibles han sido precompilados. Haga clic en "Agregar todo" para agregarlos a su carrito.',
      INPUTS_RESET_TO_ZERO: 'Las entradas se restablecen a 0.',
      ITEMS_ADDED_TO_CART: '<b>{{sumQtyAdded}}</b> artículos añadidos al carrito.',
      NO_QUANTITIES_TO_ADD: 'No hay cantidades para agregar.',
      RESET_QUANTITIES_INPUTS: 'Restablecer entrada de cantidad',
      NO_COLORS_FOUND: 'No se encontraron colores',
      NO_AVAILABLE_DATES: 'No available delivery dates',
      CHOOSE_DELIVERY_DATE: 'Fecha de entrega',
      DATES: '({{numberDate}} disponibles)',
      SUGG_RETAIL: 'Sugg retail',
      MAX: 'Max',
      SUGG: 'Sugg',
      PROMOTION_TABLE: 'Mostrar promociones',
      PRICE_TABLE: 'Mostrar precios',
      PRICE_TABLE_TITLE: 'Tabla de precios',
      PROMOTION_TABLE_TITLE: 'Tabla de promociones',
      BY_VALUE: 'Por valor de compra',
      BY_QUANTITY: 'Por cantidad de productos',
      QUANTITY: 'Cantidad',
    },

    MODAL_ATTENTION_CHANGE_ORDER_QTY: {
      LOSE_CUSTOM_DELIVERY_DATES: '¡Al cambiar las cantidades, perderá las fechas personalizadas que estableció! Recuerda restablecerlo al confirmar tu pedido',
      ARE_YOU_SURE: '¿Estás seguro?',
      CONFIRM: 'Confirmar',
    },


    PROMOTION_STEPS: {
      ITEMS_IN_THE_CART: 'Artículos en el carrito {{products}}',
      PROMOTION_DISCOUNT: 'Descuento promocional {{discount}}%',
      ADD_PCS_FOR_REACH_PROMO_DISCOUNT: 'Añadir {{value}} pcs para alcanzar el descuento promocional',
      CART_VALUE: 'Valor del carrito {{value}}',
      ADD_VALUE_FOR_REACH_PROMO_DISCOUNT: 'Añadir {{value}} para alcanzar el descuento promocional',
      PROMOTION: 'Promoción',
    },
    BULK_OPERATIONS: {
      STATUS: {
        AWAITINGPROCESSING: 'En espera de procesamiento',
        PROCESSING: 'Procesando',
        PROCESSEDWITHOUTISSUES: 'Procesado',
        PROCESSEDWITHISSUES: 'Procesado con problemas',
        PROCESSINGFAILURE: 'Error de procesamiento',
      },
      TYPES: {
        ADDNEWITEMS: 'Agregar nuevos artículos',
        REMOVEITEMS: 'Eliminar artículos',
        REPLACEITEMS: 'Reemplazar artículos',
        EDITQUANTITY: 'Cambiar cantidad',
        CHANGEITEMSDELIVERYDATE: 'Cambiar fecha de entrega',
        EDITWHOLESALEPRICE: 'Cambiar precio wholesale',
        CHANGECUSTOMERANDSHIPPINGADDRESS: 'Cambiar cliente y punto de venta',
        CANCELORDER: 'Cancelar pedidos',
        UPDATEFROMTEMPLATE: 'Actualizar desde plantilla',
        UPDATEORDERHEADER: 'Actualizar header del pedido',
      },
      SCOPES: {
        SINGLEORDER: 'Pedido único',
        MULTIPLEORDERS: 'Pedidos múltiples',
      },
      MODAL: {
        TITLE: 'Detalles de la operación',
        TAB1_TITLE: 'Log ERP',
        TAB2_TITLE: 'Issues',
      },
      BACK_TO_BULK_OPERATIONS: 'Operaciones',
      PROCESSED_ORDER_ITEMS_COUNT: 'Artículos procesados',
      PROCESSED_WITH_ISSUES_COUNT: 'Issues',
      PENDING_OPERATIONS: 'Operaciones en cola',
      LOADING_OPERATIONS: 'Cargando operaciones...',
      NO_PENDING_OPERATIONS: 'No hay operaciones en cola',
      NO_PENDING_OPERATIONS_DESC: 'Todas las operaciones para este pedido han sido procesadas.',
      TOTAL_OPERATIONS: 'Total {{count}} operaciones en cola',
      VIEW_DETAILS: 'Ver detalles',
      VIEW_PENDING_OPERATIONS: 'Ver operaciones en cola',
      CREATED_BY: 'Creado por',
      AFFECTED_ITEMS: 'Artículos afectados',
      ADD_NEW_ITEMS: 'Agregar nuevos artículos',
      REMOVE_ITEMS: 'Eliminar artículos',
      REPLACE_ITEMS: 'Reemplazar artículos',
      CHANGE_QUANTITY: 'Cambiar cantidad',
      CHANGE_DELIVERY_DATE: 'Cambiar fecha de entrega',
      CHANGE_WHOLESALE_PRICE: 'Cambiar precio wholesale',
      CHANGE_CUSTOMER_AND_POS: 'Cambiar cliente y punto de venta',
      CANCEL_ORDERS: 'Cancelar pedidos',
      UPDATEFROMTEMPLATE: 'Actualizar pedido desde plantilla',
      UPDATE_ORDER_HEADER: 'Actualizar encabezado de pedido',
      SINGLE_ORDER: 'Pedido único',
      MULTIPLE_ORDERS: 'Pedidos múltiples',
      PRODUCT: 'SKU Code-EAN',
      DELIVERY_DATE: 'Fecha de entrega',
      UNKNOWN: 'Desconocido',
      UNKNOWN_SCOPE: 'Alcance desconocido',
      ITEMS_TO_ADD: 'Artículos a agregar',
      ITEMS_TO_REMOVE: 'Artículos a eliminar',
      ITEMS_TO_REPLACE: 'Artículos a reemplazar',
      QUANTITY_CHANGES: 'Cambios de cantidad',
      DELIVERY_DATE_CHANGES: 'Cambios de fecha de entrega',
      PRICE_CHANGES: 'Cambios de precio',
      CUSTOMER_AND_POS_CHANGES: 'Cambios de cliente y punto de venta',
      CUSTOMER: 'Cliente',
      UPDATE_FROM_TEMPLATE: 'Actualizar desde plantilla',
      POINT_OF_SALE: 'Punto de venta',
      ORDER_CANCELLATION: 'Cancelar pedido',
      OLD_PRODUCT: 'SKU Code-EAN anterior',
      NEW_PRODUCT: 'Nuevo SKU Code-EAN',
      NEW_PRICE: 'Nuevo precio',
      OLD_QUANTITY: 'Cantidad anterior',
      NEW_QUANTITY: 'Nueva cantidad',
      OLD_DATE: 'Fecha anterior',
      NEW_DATE: 'Nueva fecha',
      OLD_PRICE: 'Precio anterior',
      FROM: 'De',
      TO: 'Al',
      CANCELLATION_REASON_ID: 'ID motivo cancelación',
      QUANTITY: 'Cantidad',
      DELIVERY: 'Entrega',
      REASON: 'Causal',
      PRICE: 'Precio',
      TYPE: 'Tipo de operación',
    },
    REPORTS: {
      STORE_VARIANTS: 'Variantes de producto',
      STORE_ORDERS: 'Ordenes de producto',
      STORE_ORDERS_ITEMS: 'Artículos de orden',
    },
  },
};
